import {useEffect, useRef, useState, memo} from 'react';

import {useDropzone} from 'react-dropzone';
import Select  from 'react-select';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import DatePicker from 'react-datepicker';
import MultiDatePicker from "react-multi-date-picker"
import moment from 'moment';
import {axios} from './libs/axios';
import styles from './Chat.module.css'; // Import css modules stylesheet as styles
import {moneyCurrency} from './libs/utils';
import {Media} from './components';
import MaskedInput from 'react-text-mask';
import 'font-awesome/css/font-awesome.min.css';
import { ReactComponent as Loadinganimation } from './assets/hugoloading.svg';

import SignatureCanvas from 'react-signature-canvas'
import Cookies from 'js-cookie';

import EXIF from 'exif-js';
import ExifReader from 'exifreader';


const urlData = window.urlData;
//const {chatbotId, lang = 'en', urlData} = window;
const {chatbotId, lang} = window;
const Joi = require('joi');






function Chat() {


  const localProgressId = window.localStorage.getItem(`pid_${chatbotId}`);



  const [showChat, setShowChat] = useState(true);
  const [progressId, setProgressId] = useState(localProgressId || '');
  const [conversationLength, setConversationLength] = useState();
  const [messages, setmessages] = useState([]);
  const [files, setFiles] = useState([]);
  const [waiting, setwaiting] = useState(false);
  const [auth, setauth] = useState(null);
  const [editmode, seteditmode] = useState(false);
  const [reviewhome, setreviewhome] = useState(false);
  const [validationstate, setvalidationstate] = useState(false);
  //const [progress, setProgress] = useState();
  const [maxprogress, setMaxprogress] = useState();
  const [modal, setModal] = useState(false);
  const botId = chatbotId;
  
  const [address, setAddress] = useState(null);
  const [block, setBlock] = useState({});
  const [chatbot, setChatbot] = useState(null);

  const inputRef = useRef(null);

  const [matchedLawyers, setMatchedLawyers] = useState([]);
  const [selectedLawyer, setSelectedLawyer] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  const [buttonsticky, setButtonSticky] = useState(false);


  const [showPopup, setShowPopup] = useState(false);

  const handleMoreInfoClick = (lawyer) => {
    //setSelectedLawyer(lawyer);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const loginFirstNameRef = useRef(null);
  const loginLastNameRef = useRef(null);
  const loginPhoneRef = useRef(null);
  const loginPidRef = useRef(null);
  const loginEmailRef = useRef(null);
  const loginPassword = useRef(null);
  const [loginEmail, setloginemail] = useState('');
  const [loginPhone, setloginphone] = useState('');
  const [loginFirstName, setloginfirstname] = useState('');
  const [loginLastName, setloginlastname] = useState('');
  const [loginPid, setloginpid] = useState('');

  const [loggedIn, setLoggedIn] = useState(false);
  const [clientName, setClientName] = useState('');


  const emailsRef = useRef(null);
  const shareEmail = useRef();
  const progEmail = useRef();

  const [sharevalidations, setShareValidations] = useState();
  const [sharemessagevalidations, setShareValidationsMessage] = useState();
  const [shareMessage, setShareMessage] = useState('');
  const [decisionvalidations, setDecisionValidation] = useState();
  const [validationMessage, setValidationsMessage] = useState([]);
  const [progress, setProgress] = useState();


  //const [inputValue, setInputValue] = useState('');

  const messageRef = useRef(null);

  const optionSelectRef = useRef(null);
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  //const [selectedDate, setSelectedDate] = useState(null);
  const [selectedtime, setSelectedTime] = useState(null);
  const [isFirstReply, setIsFirstReply] = useState(false);
  const [prevBlock, setPrevBlock] = useState([]);
  const [reviews, setreviews] = useState([]);

  //const [prevrepli, setPrevrepli] = useState([]);
  const [chatdata, setChatdata] = useState([]);
  const [chatInput, setchatInput] = useState('');
  const [charactercount, setCount] = useState(0);
  const [underlimit, setLimit] = useState(true);
  const [iscameracapture, setIsCameraCapture] = useState(false);

  const [error, setError] = useState(false);
  const [errorm, setErrorm] = useState('Teenuse osutamisel ilmnes probleem. Võtame sinuga esimesel võimalusel ühendust. Võimalusel proovi uuesti - selleks taaskäivita teekond.');
  const [errorm_ru, setErrormRu] = useState('Teenuse osutamisel ilmnes probleem. Võtame sinuga esimesel võimalusel ühendust. Võimalusel proovi uuesti - selleks taaskäivita teekond.');
  const [errorm_en, setErrormEn] = useState('There was a problem with your request. We will get in touch. To try again, restart.');
  const timeslots = block.timeslots || {};
  const [waitmessage, setWaitmessage] = useState(block.waitmessage);




  useEffect(() => {
    //setAddress(address.label);
  }, [address]);


  const [dataurl, setDataurl] = useState(null);

  







  const handleLogout = () => {
    Cookies.remove('auth_token'); // Just in case
    Cookies.remove('client_name'); // Remove client name
    setLoggedIn(false); 
  };

  const handleLogIn = () => {
    const name = Cookies.get('client_name')
    if(name){
      setLoggedIn(true);
      setClientName(name); // Optionally set the client's name if you're storing it in a cookie
    }

  };


  const getBlobFromPreview = (previewUrl, callback) => {
    fetch(previewUrl)
      .then(response => response.blob())
      .then(blob => callback(blob))
      .catch(error => console.error('Error in converting preview URL to blob:', error));
  };


  function fileToBlob(file, callback) {
    const reader = new FileReader();
    
    reader.onload = function(event) {
        const blob = new Blob([event.target.result], { type: file.type });
        callback(blob);
    };
    
    reader.onerror = function(error) {
        console.error('Error converting file to blob:', error);
    };
    
    reader.readAsArrayBuffer(file);
}

 /*  const {getRootProps, getInputProps} = useDropzone({
    accept: block?.acceptedTypes?.toString(),
    maxSize: block?.sizeLimit * 1000000,
    onDrop: (acceptedFiles, fileRejections) => {
      setValidationsMessage('');
      fileRejections.forEach(({ file, errors }) => {
        errors.forEach(({ code }) => {
          if (code === 'file-too-large') {
            setValidationsMessage(`Faili maksimaalne suurus on ${block.sizeLimit}MB. Valitud fail '${file.path}' on ${Math.round(file.size / 1000000)}MB.`);
          } else if (code === 'file-invalid-type'){
            setValidationsMessage(`Fail ei ole lubatud.`);
          } else if (code === 'too-many-files'){
            setValidationsMessage(`Liiga palju faile`);
          } else if (code === 'file-too-small'){
            setValidationsMessage(`Fail ei ole sobilik`);
          } else {
            setValidationsMessage(`Midagi läks valesti.`);
          }
        });
      });

      acceptedFiles.forEach(file => {
        //setFiles([...files, file]);

        resizeImage(file, 400, 300, 0.7, function (smallerFile) {
          // smallerFile is a Blob, use it in your upload logic
          //uploadFunction(smallerFile);
          console.log(smallerFile) 
          setFiles([...files, smallerFile]);

          getFileDataUrl(smallerFile, dataUrl => {
            // Now you have the data URL which you can use for previews or upload
            setDataurl(dataUrl)
            //console.log(dataUrl);
          });

        });
      });
      

      //const updatedFiles = acceptedFiles.map((file) => {
       // return Object.assign(file, {
       //   preview: URL.createObjectURL(file),
       // });
      //});
      

      //setFiles([...files, ...updatedFiles]); 
      _scroll();
    },
  }); */

  function isCameraImage(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (e) {
        try {
          const tags = ExifReader.load(e.target.result);
          if (tags.Make || tags.Model || tags.DateTimeOriginal) {
            resolve(true); // Image is from camera
          } else {
            resolve(false); // Image is not from camera
          }
        } catch (error) {
          console.error('EXIF read error:', error);
          resolve(false); // Assume not a camera image on error
        }
      };
  
      reader.onerror = function (error) {
        console.error('FileReader error:', error);
        resolve(false);
      };
      
      console.log("fin")
      reader.readAsArrayBuffer(file);
    });
  }
  


const { getRootProps, getInputProps } = useDropzone({
  accept: block?.acceptedTypes ? block.acceptedTypes.toString() : undefined,
  maxSize: block?.sizeLimit * 1000000,
  onDrop: (acceptedFiles, fileRejections) => {
    setValidationsMessage('');
    fileRejections.forEach(({ file, errors }) => {
      errors.forEach(({ code }) => {
        if (code === 'file-too-large') {
          setValidationsMessage(`Faili maksimaalne suurus on ${block.sizeLimit}MB. Valitud fail '${file.path}' on ${Math.round(file.size / 1000000)}MB.`);
        } else if (code === 'file-invalid-type') {
          setValidationsMessage(`Fail ei ole lubatud.`);
        } else if (code === 'too-many-files') {
          setValidationsMessage(`Liiga palju faile`);
        } else if (code === 'file-too-small') {
          setValidationsMessage(`Fail ei ole sobilik`);
        } else {
          setValidationsMessage(`Midagi läks valesti.`);
        }
      });
    });

    // Process each accepted file
    acceptedFiles.forEach(file => {

        if (file.type.startsWith('image/')) {
          console.log("starts with image")
           isCameraImage(file).then(isCamera => {
             console.log("ISCAMERA: ", isCamera)
              if (isCamera) {
                  // Image is from camera capture
                  console.log("IS CAMERA")
                  resizeImageForCamera(file, 1000, 800, 0.9, function (smallerFile) {
                    
                    setFiles([...files, smallerFile]);
                    getFileDataUrl(smallerFile, dataUrl => {
                      setDataurl(dataUrl);
                    });
      
                  });
              } else {
                  // Image is not from camera capture
                  console.log("NOT CAMERA")               
                  const updatedFiles = acceptedFiles.map((file) => {
                    return Object.assign(file, {
                      //preview: URL.createObjectURL(file),
                    });
                  }); 
                  setFiles([...files, ...updatedFiles]);
              }
          });
          }else{

            console.log("NOT IMAGE")
            const updatedFiles = acceptedFiles.map((file) => {
              return Object.assign(file, {
                //preview: URL.createObjectURL(file),
              });
            }); 
            setFiles([...files, ...updatedFiles]);
            
       
          }
        
      
    });
  }
});



  const { getRootProps0, getInputProps0 } = useDropzone({
    accept: block?.acceptedTypes ? block.acceptedTypes.toString() : undefined,
    maxSize: block?.sizeLimit * 1000000,
    onDrop: (acceptedFiles, fileRejections) => {
      setValidationsMessage('');
      fileRejections.forEach(({ file, errors }) => {
        errors.forEach(({ code }) => {
          if (code === 'file-too-large') {
            setValidationsMessage(`Faili maksimaalne suurus on ${block.sizeLimit}MB. Valitud fail '${file.path}' on ${Math.round(file.size / 1000000)}MB.`);
          } else if (code === 'file-invalid-type') {
            setValidationsMessage(`Fail ei ole lubatud.`);
          } else if (code === 'too-many-files') {
            setValidationsMessage(`Liiga palju faile`);
          } else if (code === 'file-too-small') {
            setValidationsMessage(`Fail ei ole sobilik`);
          } else {
            setValidationsMessage(`Midagi läks valesti.`);
          }
        });
      });
  
      // Process each accepted file
      acceptedFiles.forEach(file => {
      
            if (iscameracapture) {
             
              console.log("IS CAMERA")
              resizeImageForCamera(file, 1000, 800, 0.9, function (smallerFile) {
                
                setFiles([...files, smallerFile]);
                getFileDataUrl(smallerFile, dataUrl => {
                  setDataurl(dataUrl);
                });
               /* const updatedFile = Object.assign(smallerFile, {
                  preview: URL.createObjectURL(smallerFile),
                }); */
                //setFiles(prevFiles => [...prevFiles, updatedFile]);
               // getFileDataUrl(updatedFile, dataUrl => {
               //   setDataurl(dataUrl);
               // });
              });
              
            } else {

              console.log("NOT CAMERA")
              // Use the original file for non-camera images
           
      
              const updatedFiles = acceptedFiles.map((file) => {
                return Object.assign(file, {
                  preview: URL.createObjectURL(file),
                });
              }); 
              setFiles([...files, ...updatedFiles]);
              
              /* const updatedFile = Object.assign(file, {
                preview: URL.createObjectURL(file),
              });
              setFiles(prevFiles => [...prevFiles, updatedFile]);
              getFileDataUrl(updatedFile, dataUrl => {
                setDataurl(dataUrl);
              }); */
            }
          
        
      });
    }
  });
  
  /* 

  const { getRootProps, getInputProps } = useDropzone({
    accept: block?.acceptedTypes?.toString(),
    maxSize: block?.sizeLimit * 1000000,
    onDrop: (acceptedFiles, fileRejections) => {
      try {
        setValidationsMessage('');
        fileRejections.forEach(({ file, errors }) => {
          errors.forEach(({ code }) => {
            if (code === 'file-too-large') {
              setValidationsMessage(`Faili maksimaalne suurus on ${block.sizeLimit}MB. Valitud fail '${file.path}' on ${Math.round(file.size / 1000000)}MB.`);
            }
          });
        });
        const updatedFiles = acceptedFiles.map((file) => {
          return Object.assign(file, {
            preview: URL.createObjectURL(file),
          });
        }); 
        setFiles([...files, ...updatedFiles]);
        _scroll();
      } catch (error) {
        console.error('Error:', error);
        setMessage({msg: "Tekkis probleem"});
      }
    },
  }); */


  useEffect(() => {
    const updateChat = async () => {
      try {
        if (params?.rid) {
          await axios.put(`/redirect/${params?.rid}`);
        }
      } catch (error) {
        console.error(error);
      }
    };
    updateChat();
  }, [params?.rid]);

  const callProgressApi = async () => {
    try {
     // if(block.type === 'data'){
       // callApi()
     // }else{
      const {messages, lastMessage, length} = await axios.post(`/progress`, {progressId: params?.pid || localProgressId});
      //Take only the last message instead of all conversation history - this does not matter anymore?
      //setSecond(false);
      setmessages(messages.map((message) => ({msg: message.content, headtext:message.headtext, buttontext:message.buttontext, user: message.type})).slice(-length));
      setBlock(lastMessage);
      if (!params?.rid && params?.pid) setShowChat(true);
      removeParam('pid');
    //  }
    } catch (error) {
      setError(true)
      setErrorm("Näib, et link on aegunud. Teid suunatakse algusesse. Kui suunamine ei toimu automaatselt, klõpsake nuppu 'Taaskäivita' uuesti alustamiseks. ")
      console.error(error);
      window.setTimeout(async () => {
        removeParam('pid');
        startAgain();
      }, 2000);
    }
  };
  useEffect(() => {
    const chat = async () => {
      if (params?.pid || localProgressId) {
        callProgressApi();
      } else {
        callApi();
      }
    };
    chat();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (progressId.length > 1) {
      onFirstReply(prevBlock);
    }
  }, [progressId]); // eslint-disable-line react-hooks/exhaustive-deps



  function removeParam(paramName) {
    // Get the current URL
    const currentUrl = window.location.href;
    // Create a URL object
    const url = new URL(currentUrl);
    // Get the search parameters
    const searchParams = url.searchParams;
    // Remove the parameter
    searchParams.delete(paramName);
    // Set the search property of the URL
    url.search = searchParams.toString();
    // Update the URL without reloading the page
    window.history.pushState({}, '', url.href);
  }


 /*  function resizeImage(file, maxWidth, maxHeight, quality, callback) {
    // Create an image object
    const image = new Image();
    
    // Create a file reader
    const reader = new FileReader();
    reader.onload = function (e) {
      image.onload = function () {
        // Create a canvas and get its context
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        // Calculate the new image dimensions
        let width = image.width;
        let height = image.height;
  
        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }
  
        // Set canvas dimensions
        canvas.width = width;
        canvas.height = height;
        
        // Draw the image with the new dimensions
        ctx.drawImage(image, 0, 0, width, height);
  
        // Convert the canvas to a Blob
        canvas.toBlob(function (blob) {
          callback(blob);
        }, 'image/png', quality);
      };
  
      // Set the source of the image to the FileReader result
      image.src = e.target.result;
    };
  
    // Read the file as a Data URL (base64)
    reader.readAsDataURL(file);
  } */

    function resizeImageForCamera(file, maxWidth, maxHeight, quality, callback) {
      // Create an image object
      const image = new Image();
      
      // Create a file reader
      const reader = new FileReader();
      reader.onload = function (e) {
          image.onload = function () {
              // Create a canvas and get its context
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
  
              // Calculate the new image dimensions
              let width = image.width;
              let height = image.height;
  
              if (width > height) {
                  if (width > maxWidth) {
                      height *= maxWidth / width;
                      width = maxWidth;
                  }
              } else {
                  if (height > maxHeight) {
                      width *= maxHeight / height;
                      height = maxHeight;
                  }
              }
  
              // Set canvas dimensions
              canvas.width = width;
              canvas.height = height;
              
              // Draw the image with the new dimensions
              ctx.drawImage(image, 0, 0, width, height);
  
              // Convert the canvas to a Blob
              canvas.toBlob(function (blob) {
                  // Create a new File object from the Blob
                  const newFile = new File([blob], file.name, {
                      type: 'image/png',
                      lastModified: Date.now()
                  });
  
                  // Pass the new File object to the callback
                  callback(newFile);
              }, 'image/png', quality);
          };
  
          // Set the source of the image to the FileReader result
          image.src = e.target.result;
      };
  
      // Read the file as a Data URL (base64)
      reader.readAsDataURL(file);
  }


  function resizeImage(file, maxWidth, maxHeight, quality, callback) {
    const reader = new FileReader();
    reader.onload = function (e) {
      const arrayBuffer = e.target.result;
  
      // Load EXIF data
      let orientation = 1; // Default orientation
      try {
        const tags = ExifReader.load(arrayBuffer);
        orientation = tags.Orientation ? tags.Orientation.value : 1;
      } catch (error) {
        console.error('EXIF read error:', error);
      }
  
      // Create a blob URL for the image
      const blob = new Blob([arrayBuffer], { type: file.type });
      const image = new Image();
  
      image.onload = function () {
        let width = image.width;
        let height = image.height;
  
        // Calculate new dimensions while maintaining aspect ratio
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }
  
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
  
        // Adjust canvas size and orientation
        if (orientation > 4) {
          canvas.width = height;
          canvas.height = width;
        } else {
          canvas.width = width;
          canvas.height = height;
        }
  
        // Apply EXIF orientation
        switch (orientation) {
          case 2:
            ctx.transform(-1, 0, 0, 1, width, 0);
            break;
          case 3:
            ctx.transform(-1, 0, 0, -1, width, height);
            break;
          case 4:
            ctx.transform(1, 0, 0, -1, 0, height);
            break;
          case 5:
            ctx.transform(0, 1, 1, 0, 0, 0);
            break;
          case 6:
            ctx.transform(0, 1, -1, 0, height, 0);
            break;
          case 7:
            ctx.transform(0, -1, -1, 0, height, width);
            break;
          case 8:
            ctx.transform(0, -1, 1, 0, 0, width);
            break;
          default:
            // No transformation needed
            break;
        }
  
        ctx.drawImage(image, 0, 0, width, height);
  
        // Convert canvas to blob and create a new File object
        canvas.toBlob(function (blob) {
          const newFile = new File([blob], file.name, {
            type: file.type,
            lastModified: Date.now(),
          });
          callback(newFile);
        }, file.type, quality);
      };
  
      image.onerror = function (error) {
        console.error('Image load error:', error);
        callback(file); // Fallback to original file
      };
  
      image.src = URL.createObjectURL(blob);
    };
  
    reader.onerror = function (error) {
      console.error('FileReader error:', error);
      callback(file);
    };
  
    reader.readAsArrayBuffer(file);
  }
  
  
  
  const onReply = async (event, second = undefined) => {

    event.preventDefault();
    let userReply = '';

    if (!second) {
    if (block.inputtype === 'signature'){
      if (!signatureValid) return;
      userReply = signature
    }
    else if (block.validation === 'money') {
      console.log(inputRef.current.value)
      const currencysign = `${moneyCurrency.find((i) => i.value === block.currency).sign}`;
      console.log(currencysign)
      const temp = `${moneyCurrency.find((i) => i.value === block.currency).sign}${inputRef.current.value}`;
      console.log(temp)
      if(inputRef.current.value.includes(currencysign)){userReply = inputRef.current.value}
      else if(inputRef != null){userReply = temp}
      else{userReply = temp}

    } else if (block.validation === 'address') {
      if(chatInput){userReply = chatInput} else
      if(address != null){userReply = address.value.description}else{userReply = address;}
      //setAddress(null);
    } else if (block.validation === 'name') {
      userReply = inputRef.current.value
        .trim()
        .split(' ')
        .map((i) => i[0]?.toUpperCase() + i.slice(1)?.toLowerCase())
        .join(' ');
    } else if (block.validation === 'date') {
      //const temp = moment(new Date(chatInput)).format('DD.MM.YYYY');
      // formattimine viidud input onchange eventi külge
      userReply = chatInput;
    } else if (block.validation === 'birthday') {
      // Vaja sama lahendus lisada nagu eelneval.
      const temp = moment(new Date(chatInput)).format('DD.MM.YYYY');
      if(chatInput != null){userReply = temp}else{userReply = chatInput}
    } else if (block.validation === 'time') {
      // Vajab samal põhimõttel lahendada, nagu date
      const temp = moment(new Date(selectedtime)).format('HH:mm');
      if(selectedtime != null){userReply = temp}else if(chatInput){userReply = chatInput}else{userReply = selectedtime}
    } else {
      userReply = inputRef.current.value.trim();
    } 
    }

    if (second) userReply = "skipped";

    await reply(userReply, undefined, undefined, second);
    _scrollTop();

  };

  const  reply = async (userReply, replyText = '', newid, second) => {

    //Seda pole üldse vaja?
    setchatInput();
    setMessage({msg: replyText ? replyText : userReply, user: 'user'});
    
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    if (optionSelectRef.current) {
      optionSelectRef.current.state.value = '';
    }

    if (!isFirstReply) {
      setIsFirstReply(true);
    }

   //Kontrollida
    if(newid !== undefined){
      await callApi(block.id, userReply)
      console.log(reviewhome)
      getBlock(reviewhome)
    }
    //else if(editmode){
    //  console.log("ONEDITMODE")
    //  getBlock(reviewhome, userReply)
    //}
    else{
      //console.log(block.id, userReply, second, block)
      await callApi(block.id, userReply, second);

    }
    
    
  };

  const callApi = async (id = undefined, reply = undefined, second) => {

    setButtonSticky(false)

  
    try {
      const _promise = () => {

        setwaiting(true);
        console.log("should be hidden WAITING state")
        const promise = new Promise(function (resolve, reject) {
          window.setTimeout(async () => {

      
            const _block = await axios.post(chatbotId, {id, reply, progressId: params?.pid || localProgressId, second});
              // console.log(_block.id);
               if(_block.id === undefined){
                setError(true);
                setErrorm(dataurl)
              }  
           


            if (_block.chatProgressId) {
              window.localStorage.setItem(`pid_${chatbotId}`, _block.chatProgressId);
              setProgressId(_block.chatProgressId);
            }


            

            if (_block.id) {
           
              if (!isFirstReply) {
                setPrevBlock((prev) => [...prev, _block.id]);
              }
         

      
              if(!editmode){
                setMessage({msg: _block?.msg, headtext:_block.headtext, buttontext:_block.buttontext, type: _block.type});
                setBlock(_block);
              } else if ( editmode && _block.hasvalidation)
              {
                setMessage({msg: _block.msg, headtext:_block.headtext, buttontext:_block.buttontext, type: _block.type});
                setBlock(_block);
              }


              if (!_block.waitForReply) {
                // check for gtm
                if (_block.type === 'gtm') {
                  gtmEvent(_block);
                }
                await callApi(_block.id);
              }

            } else {

              setBlock({});
              
            }

            if (_block.hasvalidation){setvalidationstate(true)}else{setvalidationstate(false)}


            if(_block.type === 'match' && _block.matched === undefined){setwaiting(true)}
            else if(_block.type === 'calendar' && _block.timeslots === undefined){setwaiting(true)}
            else{
              setwaiting(false)
            }

            setWaitmessage(_block.waitmessage)

            resolve(_block);

            if(editmode && !_block.hasvalidation){
              setBlock({});
              setvalidationstate(false)
              getBlock(reviewhome)}

              _scrollTop();

          }, 30);
        });

        return promise;
      };
      return await _promise();
    } catch (error) {
      setwaiting(false);
      console.error(error);
    }
  };

  const setMessage = ({user = 'system', ...rest}) => {

    setmessages([]);
    setmessages((state) => {
      return [...state, {user, ...rest}];
    });
  
  };



  const uploadFile = async (id, formData) => {
    setwaiting(true);

   // setValidationsMessage(JSON.stringify(formData))
    console.log(id, formData);

    try {
      const _block = await axios.post(chatbotId, formData);
      console.log(_block); // or whatever response processing you want
      if (_block.id) {
        setBlock(_block);
        setMessage({msg: _block.msg});
        if (!_block.waitForReply) {
          await callApi(_block.id);
        }
      } else {
        console.log(_block);
        setValidationsMessage('Faili laadimisel tekkis probleem. Proovi uuesti.')
        console.error("Error uploading image:", error, _block + JSON.stringify(_block) + formData);
        alert(JSON.stringify(error));
        alert(JSON.stringify(formData))
        alert(JSON.stringify(_block))


      }
      setwaiting(false);
    } catch (error) {
      console.error("Error uploading image:", error, formData);
      alert(JSON.stringify(error));
    }

    /* const _block = await axios.post(chatbotId, formData);
    if (_block.id) {
      setBlock(_block);
      setMessage({msg: _block.msg});
      if (!_block.waitForReply) {
        await callApi(_block.id);
      }
    } else {
      setValidationsMessage('Faili laadimisel tekkis probleem. Proovi uuesti.')
    }
    setwaiting(false); */


  };

  /* const uploadFile = async (id, formData) => {
    try {
      setwaiting(true);
      setMessage({ msg: "Laen fail(e) üles..." });
      const _block = await axios.post(chatbotId, formData);
      console.log(_block)
      if (_block.id) {
        setBlock(_block);
        setMessage({ msg: _block.msg });
        if (!_block.waitForReply) {
          await callApi(_block.id);
        }
      } else {
        setMessage({ msg: "Tekkis probleem" });
      }
      setwaiting(false);
    } catch (error) {
      console.error('Error:', error);
      setMessage({ msg: "Tekkis probleem" });
    }
  }; */


  const thumbs = files.map((file) => {
    const isImage = file.type.split('/')[0] === 'image';

     


   /*  if (file.type.startsWith('image/')) {
      console.log(EXIF.getData(file), EXIF.getAllTags(file))
      EXIF.getData(file, function() {
        const allMetadata = EXIF.getAllTags(this);
        console.log(allMetadata);
        const dateTimeOriginal = EXIF.getTag(this, "DateTimeOriginal");
        console.log(`Date Time Original: ${dateTimeOriginal}`);
      });
    } */
  

    return (
      <div className={`${styles.uploadthumb} my-1`} key={file.name}>
   
              {!isImage &&  <i className="fa fa-file-text-o"></i>}
              {isImage &&  <i className="fa fa-picture-o"></i>}
              <div className="col-11">
              <div className={styles.uploadtext}>{file.name}</div>
              {/* <i>{file.type}</i>
              <p>{file.size}</p> */}
              <p><img src= {file.preview}/></p>
              </div>
          
       
        <div
          id="image-delete-button"
          onClick={() => {
            setFiles(files.filter((i) => i.preview !== file.preview));
          }}
          className=""
        >
          <i className="fa fa-trash-o red" style={{color: 'red'}}></i>
        </div>
      </div>
    );
  });
  const gtmEvent = (block) => {
    if (window.dataLayer) {
      const {event, variables = []} = block;
      const obj = {event};
      for (const {name, value} of variables) {
        obj[name] = value;
      }
      window.dataLayer.push(obj);
    } else {
      console.log('data layer not available');
    }
  };







  //todo : treat importdata like gmt event to pass importdata to data block
  // then return data block to systemblock type
 
 // const dataEvent = (block) => {
 //   if (window.dataLayer) {
 //     const {event, variables = []} = block;
 //     const obj = {event};
 //     for (const {name, value} of variables) {
 //       obj[name] = value;
 //     }
 //     window.dataLayer.push(obj);
 //   } else {
 //     console.log('data layer not available');
 //   }
 // };
 


  const replyWithWebFunction = (funcName) => {
    if (window[funcName] && typeof window[funcName] === 'function') {
      const selectedValue = window[funcName]();
      if (selectedValue) {
        reply(selectedValue);
      }
    }
  };

//?
const onFirstReply = async (prevBlock = []) => {
  //console.log("onfirstreply")
  try {
    setwaiting(true);
    await axios.setFirstReplyBlocks(prevBlock, chatbotId);
  } catch (error) {
    console.error(error);
  } finally {
    setwaiting(false);
  }
};


const translations = {
  'en': {
    firstAvailableTime: "First available time:",
    perMinute: "€ / 25 minutes",
    perHalfHour: "€ / 30 minutes",
    perHour: "€ / hour",
    lawyerFee: "Lawyer fee",
    location: "Location",
    experience: "Experience",
    readMore: "Read more",
    overview: "Lühikene ülevaade",
    achievments: "Olulisemad saavutused",
    areas: "Õigusvaldkonnad",
    work: "Tööalane kogemus",
    education: "Haridus"

  },
  'ru': {
    firstAvailableTime: "Первое доступное время:",
    perMinute: "€ / 25 минут",
    perHalfHour: "€ / 30 минут",
    perHour: "€ / час",
    lawyerFee: "Гонорар юриста",
    location: "Местоположение",
    experience: "Опыт",
    readMore: "Подробнее"
  },
  'et': {
    firstAvailableTime: "Esimene vaba aeg:",
    perMinute: "€ / 25 minutit",
    perHalfHour: "€ / 30 minutit",
    perHour: "€ / tund",
    lawyerFee: "Juristi tasu",
    location: "Asukoht",
    readMore: "Loe rohkem",
    experience: "Kogemus",
    overview: "Lühikene ülevaade",
    achievments: "Olulisemad saavutused",
    areas: "Õigusvaldkonnad",
    work: "Tööalane kogemus",
    education: "Haridus"

  }
};

const getTranslation = (key, lang) => {
  return translations[lang] ? translations[lang][key] : translations['ru'][key];
};



useEffect(() => {
    //console.log(block)
    
    setWaitmessage(block.waitmessage)
    


    const authenticate = async () => {


      if (block.type === 'login'){
        setloginemail(block?.email);
        setloginphone(block?.phone);
        setloginfirstname(block?.firstname);
        setloginlastname(block?.lastname);
        setloginpid(block?.pid);
      }



      if (block.type === 'login' && block.email_name.length < 1){
          console.log("Not auth yet")
          let reply = [];
          reply.push("");
          await callApi(block.id, reply, false);

      }else if(block.type === 'login' && auth === null) {
        if (auth === null) {
          let reply = [];
          reply.push("");
          await callApi(block.id, reply, false);
          // Set a timeout before calling setauth
          setTimeout(() => {
            setauth(true);
          }, 0); 
        }
      }

    };


    authenticate();
    handleLogIn()
     

    if (block.type === 'match' && block.matched === undefined){
      console.log("matched still undefined ")
      setwaiting(true)
      let userReply = [];
      callApi(block.id, userReply, false);

    }

    if (block.type === 'calendar' && block.timeslots === undefined){
      let userReply = [];
      callApi(block.id, userReply, false);
    }
    
    if (block.type === 'data') {
      if(Object.keys(urlData).length > 0){
          reply(urlData);
      } else {
          reply('0');
      }
    }

    if (block.type === 'payment') {

      const isPaymentPaid = chatdata.some(item => item.variable === 'payment_status' && item.value === 'PAID');
      if (isPaymentPaid) {
        var action = 'movetonext';
        let datas = { action, botId };
        reply(datas);
      } 


      const isPaymentPending = chatdata.some(item => item.variable === 'payment_status' && item.value === 'PENDING');
      const paymentSuccessItem = chatdata.find(item => item.variable === 'payment_success');
      // Check if payment_success exists and is strictly false


      const isPaymentCanceled = paymentSuccessItem !== undefined && paymentSuccessItem.value === 'false' ? true : false;
      console.log("PENDING ", isPaymentPending, "Canceled ", isPaymentCanceled, "AND ", block.paymentcheck)      

      if (isPaymentPending && isPaymentCanceled !== false && block.paymentcheck !== 'success' && !window.urlData['order-token']) {
        console.log("SIIIIIIIIIN")
        var action = 'paymentcheck';
        let datas = { action, botId };
        reply(datas);
      } 


      //Open payment link
      if(block?.link){
        window.location.href = block.link;
      }

      //Confirm payment, if not confirmed yet and delete urldata if it has been sent forward.
      if(window.urlData['order-token'] && block?.success === undefined){
          console.log("confirm payment")
          reply(urlData, chatbotId);
          window.history.pushState({}, document.title, "/");
          window.urlData = "";
      } else if (Object.keys(window.urlData).length > 0){
      
        }
    
    }


    if (block.type === 'teleport') {


      getTeleportData().then(dataurl => {

        if(block?.link){
          //Use this to save the previous block to the conversation history
          getPreviousBlock()
          window.setTimeout(async () => {
            if(dataurl){
            window.location.href = block.link+dataurl;}else{
              window.location.href = block.link
            }
          }, 100);
        }else{
          reply(urlData);
        }


      }).catch(error => {
        console.error(error);
      });


     
    }


    getChatDataMain();
    /* scrollLoad() */
    getBot();




  }, [block]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (block.matched) {
      console.log(block.matched)
      setMatchedLawyers(block.matched);

      if (selectedLawyer) {
        const isLawyerMatched = block.matched.some(
          (lawyer) => lawyer.name === selectedLawyer.name
        );
      
        if (isLawyerMatched) {
          console.log("SEE JURIST:", selectedLawyer.name, matchedLawyers);
          setButtonSticky(true);
        } else {
          setSelectedLawyer(null)
        }
      }

      
    }
  }, [block.matched]);

  useEffect(() => {
    if (block.type === 'calendar'){
      if (selectedSlot) {
          setButtonSticky(true);
      }
    }
    if (block.type === 'review') {
      getChatData();
    }
    if (block.type === 'teleport') {
     
      
    }
  }, [block]); // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    if (block.type === 'share') {
      setShareMessage(shareMessage ? shareMessage : block?.defaultmessage) ;

      setTimeout(() => {
        resizeTextarea();
      }, 20);
     
    }

    console.log("NEED:", selectedSlot, selectedLawyer)
  }, [block]); // eslint-disable-line react-hooks/exhaustive-deps



  useEffect(() => {
    if (block.webFunction) {
      switch (block.type) {
        case 'multipleChoice':
          replyWithWebFunction(block.webFunction);
          break;
        default:
          break;
      }
    }
  }, [block]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (showChat) {
      
    }
  }, [showChat]);


  function getFileDataUrl(file, callback) {
    const reader = new FileReader();
    reader.onloadend = function() {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  }



  //AUTOMATIC solution that calculates number of progress blocks - this cant be used in manual approach.
  /* const getProgressTree = async () => {
    try {

      //Working on PROGRESSTREE here
      //const botget = await axios.getBotBlocks('6304c834c0927eabf49d0217');
      //console.log(botget);


      console.log(chatbot);
      const bot = await axios.getBot(botId);
      console.log(bot)
      setChatbot(bot);
      
      //OLULINE : SEDA VÄÄRTUST ON VAJA AINULT ÜHE KORRA SISSE LAADIDA, selle peaks laadima kui esimest korda laeb
      //Kontrollida


      const maxprogress_v = await axios.getBotMaxProgress(botId)
      const prog = 100 * block.progress / maxprogress_v[0];
      console.log(prog, maxprogress_v[0]);

      setProgress(prog);
      setMaxprogress(maxprogress_v[0]);

    } catch (error) {
      console.error(error);
    }
  };  */


  /* TODO FIX: Get previously entered data from conversation and use as predefined choices in blocks
  this should fire only once. Use block counter? If blockcount < 2   
  PROBLEM: Data changes every time, so it is not possible to fire once. 
  SOLUTION: Keep data in some react variable state and use it as a reference.
  Need to fire only first time, and set it loaded.
  */
  const getChatDataMain = async () => {
    try {

      //console.log(botId)
      const ch = await axios.getCurrentConversation(botId);
      // if (ch.chatbot === undefined) return;
      console.log(block.progress, ch.messages)
      setConversationLength(ch.messages.length);
      console.log(messages.length)
      let data = ch.data


      //let ready = "ready";  use this to call for tree only once
      let chatData = [];
      if (data === undefined) return;
      Object.keys(data).forEach(function(key, index) {
        chatData.push({
            variable: Object.getOwnPropertyNames(data)[index],
            value:data[key],
          });
      });
      
       //console.log(chatData)
       setChatdata(chatData);

       if(block.variable){
        let el = chatdata.find(item=>item.variable === block.variable);
        //console.log(block.variable)
        //console.log(chatdata)
        //console.log(chatInput);
        //console.log(el)
        if(el){
          var inputmes = el.value;
          console.log("SETTING CHAT DATA: " + el.value)
          setchatInput(inputmes ? inputmes : '')}
          if (inputmes){setButtonSticky(true)}
          
        }


    } catch (error) {
      console.error(error);
    }
  };




  //Kas saan eelmisega kokku panna?
  const getChatData = async () => {
    try {

      const ch = await axios.getCurrentConversation(botId);
      let data = ch.data
      //Kust tuleb õige conversation? Mul on vaja just praeguse kasutaja oma ainult.


      console.log(data);

      let ready = "ready";
      let reviewelementsData = [];
      for (let i = 0; i < block?.reviews.length; i++) {    
        const data = await axios.getBlockData(botId, block.reviews[i].element.value);
        //console.log(data);
        reviewelementsData.push({
          headtext: data.inputname,
          id:data.id,
         });
        //console.log(block.reviews[i].element, data.headtext, data.id);
      }

      console.log(reviewelementsData)

      setreviews({reviewelementsData, data, ready});
      console.log(reviews)
      setreviewhome(block.id);
      seteditmode(false);

      
    } catch (error) {
      console.error(error);
    }
  };


  const getTeleportData = async () => {
    try {

      const ch = await axios.getCurrentConversation(botId);
      let data0 = ch.data
      let dataurl = "";

      if(block?.reviews.length > 0){
      for (let i = 0; i < block?.reviews.length; i++) {    
        const data = await axios.getBlockData(botId, block.reviews[i].element.value);
        dataurl += '&'+data.variable+'='+data0[data.variable]
      }}
      else{
        dataurl = "";
      }
      console.log("THIS is dataurl", dataurl)
      return dataurl;
      
    } catch (error) {
      console.error(error);
    }
  };

  const getPreviousBlock = async () => {
    console.log("EELMINE: " + block.previous)
   
   //uus lahendus:
    // getBlock_(block.previous)
   
    // vana lahendus:
    try {
      setDecisionValidation('');
      if(editmode){return}
      if(validationstate){setvalidationstate(false)}
      const blocktype = block.type;
      window.setTimeout(async () => {

      let _block = await axios.getPreviousBlock(chatbotId, blocktype);

      // Keep fetching previous blocks until the type is not 'data', 'condition', or 'calculation'
      while (_block.type === 'data' || _block.type === 'condition' || _block.type === 'calculation' || _block.type === 'ai' || _block.type === 'login') {
          _block = await axios.getPreviousBlock(chatbotId, _block.blocktype);
      }  

      setMessage({msg: _block.msg, buttontext:_block.buttontext, type: _block.type});
      setBlock(_block);

      /* const _block = await axios.getPreviousBlock(chatbotId, blocktype);
      if(_block.type === "data" || _block.type === 'condition' || _block.type === 'calculation'){
        const _block2 = await axios.getPreviousBlock(chatbotId, _block.blocktype);
        setMessage({msg: _block2.msg, buttontext:_block2.buttontext, type: _block2.type});
        setBlock(_block2);
      }else{
        setMessage({msg: _block.msg, buttontext:_block.buttontext, type: _block.type});
        setBlock(_block);
      } */
   


      setwaiting(false);
      _scrollTop();
      }, 100);
    } catch (error) {
      setwaiting(false);
      console.error(error);
    }

  };

  const _moveToNext = async (id) => {

    try {
      window.setTimeout(async () => {

        
        let _block = await axios.getBlock2(chatbotId, id); 

        setMessage({msg: _block.msg, buttontext:_block.buttontext, type: _block.type});
        console.log("aaaa " +_block.type, _block.next, _block.previous, _block.id)

        setBlock(_block);

        setwaiting(false);
      }, 100);
    } catch (error) {
      console.error(error);
    } finally {
      setwaiting(false);
    }
  };

  const getBlock_ = async (id, reply) => {

    try {
      window.setTimeout(async () => {

        
        let _block = await axios.getBlock2(chatbotId, id); 


        //Need to find a different way, as I dont know how long this line could be
        if(_block.type === 'data' || _block.type === 'login' || _block.type === 'ai'){
          _block = await axios.getBlock2(chatbotId, _block.previous);
          if(_block.type === 'data' || _block.type === 'login' || _block.type === 'ai'){
            _block = await axios.getBlock2(chatbotId, _block.previous);

          }
        }


        setMessage({msg: _block.msg, buttontext:_block.buttontext, type: _block.type});
        console.log("aaaa " +_block.type, _block.next, _block.previous, _block.id)

        setBlock(_block);

        setwaiting(false);
      }, 100);
    } catch (error) {
      console.error(error);
    } finally {
      setwaiting(false);
    }
  };

  const getBlock = async (id, reply) => {

    try {
      window.setTimeout(async () => {

        const _block = await axios.getBlock(chatbotId, id);
        setMessage({msg: _block.msg, buttontext:_block.buttontext, type: _block.type});
        setBlock(_block);
        seteditmode(true);      

        setwaiting(false);
      }, 100);
    } catch (error) {
      console.error(error);
    } finally {
      setwaiting(false);
    }
  };


  /* 
    Get bot info in the begginning. Load only once
  */
  const getBot = async () => {
    try {

      const ch = await axios.getBot(botId);
      //if(ch.chatbot === null) return;
      //console.log(ch)
      if(ch.chatbot.progress === undefined) return;
      setProgress(ch.chatbot.progress)
      console.log(progress)
      setMaxprogress(ch.chatbot.progress.length);

    } catch (error) {
      console.error(error);
    }
  };










  /* Handle scroll and elements show and hide */
  const [menushow, setmenuShow] = useState(true);
  const [buttonshow, setbuttonShow] = useState(true);

  const body = useRef();
  const messagecontainer= useRef();
  const replycontainer = useRef();
  const contentcontainer = useRef();
  
  useEffect(() => {
    if (replycontainer.current) {
     
      setTimeout(
        console.log(replycontainer.current.offsetHeight)
        , 100);
    }
  }, [replycontainer]);
  
  /* const scrollLoad = () => {
    setTimeout(() => { 
      if( replycontainer.current &&
        messagecontainer.current &&
        window.innerHeight - replycontainer.current.scrollHeight - messagecontainer.current.scrollHeight < 150){
        setbuttonShow(false);
      }else{
        setbuttonShow(true);
      }
    }, 10); 
  } */
  const handleScroll = event => {

    console.log(window.innerHeight - contentcontainer.current.scrollHeight)
    if (event.currentTarget.scrollTop > 20) { // if scroll down hide the navbar
      setmenuShow(false); 
    } else { // if scroll up show the navbar
      setmenuShow(true);  
    }

      /* buttonshow */
      /* if (event.target.scrollHeight - window.innerHeight - event.target.scrollTop > 50) { // if scroll down hide the navbar
        setbuttonShow(false); 
      } else { // if scroll up show the navbar
        setbuttonShow(true);  
      } */


    

  };


  const handleLawyerSelect = (lawyer) => {
    setSelectedLawyer(lawyer);
    setchatInput(lawyer);
    setButtonSticky(true)
  };
  const handleSlotSelect = (slot) => {
    console.log(slot);
    setSelectedSlot(slot);
    setchatInput(slot);
    setButtonSticky(true);
  };

  //Needs fallback?
  const _scroll = () => {
    const chatBody = document.getElementById('chat-body');
    if (chatBody) {
      chatBody.scroll({top:chatBody?.scrollHeight, left: 0, behavior: 'smooth' });
       //chatBody.scrollTop = chatBody?.scrollHeight;
    }
  };
  const _scrollTop = () => {
    const chatBody = document.getElementById('chat-body');
    if (chatBody) {
      chatBody.scroll({top:0, left: 0, behavior: 'smooth' });
    }
  }





  const handleShowChat = () => {
    if (!showChat) {
    }
    setShowChat(!showChat);
  };


  const handleInputChange = (maxChars) => (event) => {
    setchatInput(event.target.value);
    const value = event.target.value;
    setCount(value.length);


   /*  if(block?.characterlimit !== null){
      if (value.length <= maxChars) {
      // setText(value);
        setLimit(true)
        setCount(value.length);
      }else{
        setLimit(false)
      }
    } */

    if (block?.characterlimit !== undefined && block?.characterlimit !== null) {
      if (value.length <= maxChars) {
        setLimit(true);
        setCount(value.length);
      } else {
        setLimit(false);
      }
    }
  };


  const [radioChoice, radioChoiceProps] = useRadioButtons("platform");

  function useRadioButtons(name) {
    const [value, setState] = useState(null);
  
    const handleChange = e => {
      console.log(e.target.value)
      setState(e.target.value);
    };
  
    const inputProps = {
      name,
      type: "radio",
      onChange: handleChange
    };
  
    return [value, inputProps];
  }


  function openModal() {
    setModal(true);
  }
  function closeModal() {
    setModal(false);
  }


  function setOption(i){
    optionlist.push(
    {label: i, value: i});
    addComponent(i);
  }
  const optionlist = [
    {label: 1, value: 1},
    {label: 2, value: 2},
  ];


  //For share block emaillist
  const [components, setComponents] = useState([]); 

  function addComponent(i) { 
    setComponents([...components, i])   
  } 
  function removeComponent(index) {
    setComponents(components.filter((i) => i !== index))
  }





  const startAgain = async () => {
    const chatbotId = window.chatbotId;
    localStorage.removeItem(`pid_${chatbotId}`);
    if(block.finish){
      await axios.setNewConversation(chatbotId);
    }
    window.location.reload();
  };
  
  function toggleNav() {
   

    if (document.getElementById('chat_side_navbar').classList.contains(`${styles['closed']}`)) {
      document.getElementById('chat_side_navbar').classList.remove(`${styles['closed']}`);
      document.getElementById('menuicon').classList.add(`${styles['icon-open']}`); 
      if(!block?.isProgress){document.getElementById('headerlogo')?.classList.add(`${styles['hidden']}`);}

      if(window.innerWidth<768 && block.isProgress){
        document.getElementById('progress-nav').classList.add(`${styles['hidden']}`);
       }
    } else {
      document.getElementById('chat_side_navbar').classList.add(`${styles['closed']}`);
      document.getElementById('menuicon').classList.remove(`${styles['icon-open']}`);
     
     if(!block.isProgress){ document.getElementById('headerlogo').classList.remove(`${styles['hidden']}`);}
      if(block.isProgress){
        document.getElementById('progress-nav').classList.remove(`${styles['hidden']}`);
       }

    }


  

   /*  switch (lang) {
      case 'de':
        document.getElementById('startagainbtn').innerHTML = 'Chat neu starten';
        break;
      case 'en':
        document.getElementById('startagainbtn').innerHTML = 'Restart';
        break;
      case 'tr':
        document.getElementById('startagainbtn').innerHTML = 'Sohbeti Yenile';
        break;
      case 'et':
        document.getElementById('startagainbtn').innerHTML = 'Alusta uuesti';
        break;
      default:
        document.getElementById('startagainbtn').innerHTML = 'Restart';
    } */
  }


  function MoreOptions() {

    const progressIdExist = window.location.href.includes('pid');
    
   

    return (
      <>
        <div  >
        <div onClick={toggleNav} className={`${styles['menu-btn']}`}>
        <i  id="menuicon" className={`${styles['menu-icon']} fa `}></i>
        </div>
        <div id="chat_side_navbar" className={`${styles['sidenav']} ${styles['closed']}`}>

          <div className='input-group'>
            
             {lang === "en" ? (

              <>
               {!progressIdExist && (

                  <button id="startagainbtn" onClick={startAgain} className={`${styles['menu-button']}`}>
                    Restart
                    <span>Something went wrong? Don't worry, restart the application and start again.
                    </span>
                  </button>

                  )}


                  <button onClick={openGeneralModal} className={`${styles['menu-button']}`}>
                  Save journey
                  <span>Don't have time right now? Save your progress and continue later. We will send you a link via email.</span>
                  </button>


                  <button className={`${styles['menu-button']}`}>
                    Client support
                  <span>Need help with something? Write to us.
                    <a href="mailto:hugo@hugo.legal?subject=Klienditugi" target="_blank" rel="noopener noreferrer">
                      hugo@hugo.legal
                    </a> või helista
                    <a href="tel:+372  6880 400" target="_blank" rel="noopener noreferrer">
                      +372  6880 400
                    </a>
                  </span>   
                  </button>

                  <button  className={`${styles['menu-button']}`}>
                    About
                    <span>HUGO.legal is the largest legal aid platform in Estonia. Read more 
                      <a href="https://hugo.legal/meeskond/" target="_blank" rel="noopener noreferrer">
                      about us.
                      </a>
                    </span>
                  </button>

              </>

             ): lang === "et" ? (
              <>

              {!progressIdExist && (

                <button id="startagainbtn" onClick={startAgain} className={`${styles['menu-button']}`}>
                  Taaskäivita
                  <span>Midagi läks valesti? Ära muretse, taaskäivita rakendus  ja alusta uuesti.</span>
                </button>

              )}
              
        
              <button onClick={openGeneralModal} className={`${styles['menu-button']}`}>
              Salvesta progress
              <span>Ei ole aega praegu? Salvesta progress ja jätka hiljem. Saadame Sulle lingi maili peale.</span>
              </button>
        

              <button className={`${styles['menu-button']}`}>
                  Klienditugi
                <span>Vajad millegagi abi? Kirjuta meile 
                  <a href="mailto:hugo@hugo.legal?subject=Klienditugi" target="_blank" rel="noopener noreferrer">
                    hugo@hugo.legal
                  </a> või helista
                  <a href="tel:+372  6880 400" target="_blank" rel="noopener noreferrer">
                    +372  6880 400
                  </a>
                </span>   
              </button>

              <button  className={`${styles['menu-button']}`}>
                  Meist
                  <span>HUGO.legal on Eesti suurim õigusabi platvorm. Loe meist lähemalt 
                    <a href="https://hugo.legal/meeskond/" target="_blank" rel="noopener noreferrer">
                     siit.
                    </a>
                  </span>
              </button>

      

              <div>
   
  </div>

              </>
              ):(
                <>
  
                {!progressIdExist && (
  
                  <button id="startagainbtn" onClick={startAgain} className={`${styles['menu-button']}`}>
                    Перезапустить
                    <span>Что-то пошло не так? Не беспокойтесь, перезапустите приложение и начните заново.</span>
                  </button>
  
                )}
                
          
                <button onClick={openGeneralModal} className={`${styles['menu-button']}`}>
                 Сохранить прогресс
                <span>Нет времени сейчас? Сохраните прогресс и продолжите позже. Мы отправим Вам ссылку по электронной почте.</span>
                </button>
          
  
                <button className={`${styles['menu-button']}`}>
                 Служба поддержки клиентов
                  <span>Нужна помощь? Напишите нам на 
                    <a href="mailto:hugo@hugo.legal?subject=Klienditugi" target="_blank" rel="noopener noreferrer">
                      hugo@hugo.legal
                    </a> или позвоните по номеру
                    <a href="tel:+372  6880 400" target="_blank" rel="noopener noreferrer">
                      +372  6880 400
                    </a>
                  </span>   
                </button>
  
                <button  className={`${styles['menu-button']}`}>
                    О нас
                    <span>HUGO.legal - крупнейшая в Эстонии платформа юридической помощи. Подробнее о нас читайте здесь.
                      <a href="https://hugo.legal/meeskond/" target="_blank" rel="noopener noreferrer">
                       здесь.
                      </a>
                    </span>
                </button>
  
                </>
                )}



            </div>

            
            <div onClick={toggleNav} className={`${styles['sidenav-bottom']}`}></div>
          
        </div>
     
        </div>
        
      </>
    );
  }

  function SendProgressUrl() {


    const progressIdExist = window.location.href.includes('pid');
    const generateProgressURL = () => {
      if (window.location.href.includes('rid')) {
        return `${window.location.origin}${window.location.pathname}?pid=${progressId}`;
      } else if (progressIdExist) {
        return window.location.href;
      } else {
        return `${window.location.href}?pid=${progressId}`;
      }
    };
    const sendProgress = () => {
      let progurl = "";
      let email = progEmail.current.value;
      let {lang} = window;
      
      if (window.location.href.includes('rid')) {
        progurl = `bot=${botId}&pid=${progressId}`;
      } else {
        progurl = `bot=${botId}&pid=${progressId}`;
      }
      var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(email.match(mailformat)){
        const send = axios.emailProg(progurl, email, lang);
        console.log(progurl, email)
        setIsModalOpen(false);
      }else{
        alert("Not an email");
        document.getElementById('progemail').focus();
      }
      
/*       try {
        const send = axios.emailProg(progurl, email);
        console.log(progurl, email)
      } catch (error) {
        console.error(error);
      } */
  
    };



  
    return (
      <>


        { lang == 'et' ? (

          <>
              <div className={`${styles['modal_header']}`}>
                Salvesta progress ja jätka hiljem
              </div>
         

                <div className={styles['modal-input']}>
                  <label htmlFor="name"  /* className={styles['inputname']} */>
                  Sisesta oma email, kuhu poolelioleva progressi saadame: 
                  </label>
                 
                  <input                       
                    ref={progEmail} 
                    id="progemail"
                    className={styles['formInput']}
                    placeholder="Sisesta oma email"
                    >  
                    </input>

                    {/* <label htmlFor="name">
                    Või kopeeri url:
                    </label>
                    <code id="progress-url" className={styles['progress_url']}>
                       {generateProgressURL()}
                    </code> */}
                 
                </div>

     

                <div className="d-flex justify-content-end row">
                  <button className={`${styles['light-btn']}`} onClick={closeGeneralModal}>
                    Katkesta
                  </button>
                  <button onClick={sendProgress} className={`${styles['main-btn']}`}>
                    Saada
                  </button>
                </div>
              </>
            ) :  lang === "en" ? (
              <>
            <div className={`${styles['modal_header']}`}>
                Save progress and continue later
              </div>
         

                <div className={styles['modal-input']}>
                  <label htmlFor="name"  /* className={styles['inputname']} */>
                  Enter your email to send the progress to: 
                  </label>
                 
                  <input                       
                    ref={progEmail} 
                    id="progemail"
                    className={styles['formInput']}
                    placeholder="Email address"
                    >  
                    </input>

                    {/* <label htmlFor="name">
                    Või kopeeri url:
                    </label>
                    <code id="progress-url" className={styles['progress_url']}>
                       {generateProgressURL()}
                    </code> */}
                 
                </div>

     

                <div className="d-flex justify-content-end row">
                  <button className={`${styles['light-btn']}`} onClick={closeGeneralModal}>
                    Cancel
                  </button>
                  <button onClick={sendProgress} className={`${styles['main-btn']}`}>
                    Send
                  </button>
                </div>
                </>
            ) : (
              <>
              <div className={`${styles['modal_header']}`}>
               Сохраните прогресс и продолжите позже. Мы отправим Вам ссылку на электронную почту.
              </div>
         

                <div className={styles['modal-input']}>
                  <label htmlFor="name"  /* className={styles['inputname']} */>
                  Введите Вашу электронную почту:
                  </label>
                 
                  <input                       
                    ref={progEmail} 
                    id="progemail"
                    className={styles['formInput']}
                    placeholder="электронную почту"
                    >  
                    </input>

                    {/* <label htmlFor="name">
                    Või kopeeri url:
                    </label>
                    <code id="progress-url" className={styles['progress_url']}>
                       {generateProgressURL()}
                    </code> */}
                 
                </div>

     

                <div className="d-flex justify-content-end row">
                  <button className={`${styles['light-btn']}`} onClick={closeGeneralModal}>
                    Прервать
                  </button>
                  <button onClick={sendProgress} className={`${styles['main-btn']}`}>
                    Отправить
                  </button>
                </div>
                </>
            )}
        
      </>
    );
  }


  const resizeTextarea = () => {
    if (!messageRef.current) return;
    const textarea = messageRef.current;
    textarea.style.height = 'auto';
    textarea.style.height = textarea.scrollHeight + 'px';
  };


  const [isModalOpen, setIsModalOpen] = useState(false);
  const openGeneralModal = () => {
    setIsModalOpen(true);
  };
  const closeGeneralModal = () => {
    setIsModalOpen(false);
  };




  /* SIGNATURE */

  const sigRef = useRef();
  const [signature, setSignature] = useState(null);
  const [signatureValid, setSignatureValid] = useState(null);
  const [signatureValidation, setSignatureValidation] = useState(false);


  const handleSignatureEnd = () => {
    setSignature(sigRef.current.getTrimmedCanvas().toDataURL());
    setSignatureValid(true);
    setSignatureValidation(false)
  }
  const clearSignature = () => {
    sigRef.current.clear();
    setSignature(null);
    setSignatureValid(false);
  }





  return (
    <>

      {isModalOpen && (
        <>
       
          <div className={`${styles['modal-content']}`} >
            <span className={`${styles['modalclose']}`} onClick={closeGeneralModal}>
              &times;
            </span>           

             <SendProgressUrl />

          </div>
        
        <div className={`${styles['modalbg']}`} onClick={closeGeneralModal}></div>
        </>
      )}
      {modal &&(
                  <>
                    <div className={`${styles['modalcontainer']}`}>
                      <i className={`${styles['modal-close']} fa fa-times`} onClick={closeModal}></i>
                      <div className={`${styles['modalheader']}`}>{block.modallink}</div>
                      <div  className={`${styles['modalcontent']}`}
                       dangerouslySetInnerHTML={{__html: block.modal}}></div>
                    </div>
                    <div className={`${styles['modalbg']}`} onClick={closeModal}></div>
                 </>
      )}

                 {showPopup && selectedLawyer && (
                      <div className={styles['popup-layer']}>
                        <div className={styles['area-close']} onClick={handleClosePopup}></div>
                        <div className={styles['popup-content']}>
                          <button className={styles['close-popup']} onClick={handleClosePopup}><i className={`fa fa-sharp fa-solid fa-angle-left`}></i> Tagasi</button>
                          <img src={selectedLawyer.picture} alt={selectedLawyer.name} className={styles['popup-image']} />
                          <div className={styles['lawyer-name']}>{selectedLawyer.name}</div>
                          <span className={styles['lawyer-price']}>{selectedLawyer.hourly_price} </span>
                          <span className={styles['blue']}>{getTranslation('perHour', block?.lang)}</span>
                          <br/><br/>
                          <p><b>{getTranslation('location', block?.lang)}: {selectedLawyer.city}</b><br/>
                          <b>{getTranslation('experience', block?.lang)}: {selectedLawyer.experience_years} aastat</b></p>


                          <b className={`${styles['blue']}`}>{getTranslation('overview', block?.lang)}</b>
                          <p>{selectedLawyer[`overview_${block.lang || 'et'}`]}</p>

                          <b className={`${styles['blue']}`}>{getTranslation('achievments', block?.lang)}</b>
                          <p> {selectedLawyer[`achievments_${block.lang || 'et'}`]}</p>

                          
                          <b className={`${styles['blue']}`}>{getTranslation('areas', block?.lang)}</b>
                          <p> {selectedLawyer[`areas_${block.lang || 'et'}`]}</p>

                          
                          <b className={`${styles['blue']}`}>{getTranslation('work', block?.lang)}</b>
                          <p> {selectedLawyer[`work_${block.lang || 'et'}`]}</p>
                          
                          <b className={`${styles['blue']}`}>{getTranslation('education', block?.lang)}</b>
                          <p> {selectedLawyer[`education_${block.lang || 'et'}`]}</p>


                        </div>
                      </div>
                    )}



      <div  onClick={handleShowChat} className={`${styles['chat-opener']} chat-opener-btn`}></div>
      {showChat && (
        <div className={`${styles['app']}`}>
        <div className={`${styles['app-header']} ${menushow === false ? styles['scroll'] : ''}`}>
            <MoreOptions progressId={progressId} />
           
        </div>
        {progress !== undefined && block.progress !== '+' && block.progress !== '' && block.finish !== true ? (
              <div className={`${styles['progress-container']} ${editmode === true ? styles['progresseditmode'] : ''}`}>
                  <div id='progress-nav' className={styles['progress-nav']}>
                  {conversationLength > 1 && !waiting &&
                  <span onClick={() => getPreviousBlock()} className={`${styles['left-button']} ${menushow === false ? styles['scroll'] : ''}`}> <i     className={`fa fa-sharp fa-solid fa-angle-left`}></i> </span>
                  }

                  {!waiting &&
                    <>
                    {block.type === 'input' ? (
                        <span onClick={ async (e) => { onReply(e) }} className={`${styles['right-button']} ${menushow === false ? styles['scroll'] : ''}`}> <i className={`fa fa-sharp fa-solid fa-angle-right`}></i> </span>

                    ): block.type === 'decision' ? (
                        <span onClick={ async (e) => { 
                          if (!chatInput){
                            setDecisionValidation(block?.validationMessage)
                            _scroll();
                          } else {
                            setDecisionValidation('');
                            reply(chatInput);
                          }
                        }} className={`${styles['right-button']} ${menushow === false ? styles['scroll'] : ''}`}> <i className={`fa fa-sharp fa-solid fa-angle-right`}></i> </span>

                    ): block.type === 'text' && block.button ?(
                      <span onClick={ async (e) => { reply('0') }} className={`${styles['right-button']} ${menushow === false ? styles['scroll'] : ''}`}> <i className={`fa fa-sharp fa-solid fa-angle-right`}></i> </span>

                    ): block.type === 'multipleChoice' ?( 

                      <span onClick={ async (e) => { 
                        if (!chatInput){
                          setDecisionValidation(block?.validationMessage)
                          _scroll();
                        } else {
                          setDecisionValidation('');
                          reply(chatInput);
                        }
                      }} className={`${styles['right-button']} ${menushow === false ? styles['scroll'] : ''}`}> <i className={`fa fa-sharp fa-solid fa-angle-right`}></i> </span>

                    ): block.type === 'review' ? (
                      <span onClick={ async (e) => {  reply('0'); }} className={`${styles['right-button']} ${menushow === false ? styles['scroll'] : ''}`}> <i className={`fa fa-sharp fa-solid fa-angle-right`}></i> </span>
                    ): block.type === 'share' ?(
                      <span onClick={ async (e) => {  reply(false); }} className={`${styles['right-button']} ${menushow === false ? styles['scroll'] : ''}`}> <i className={`fa fa-sharp fa-solid fa-angle-right`}></i> </span>
                    ):(<div></div>)}
                    </>
                    }

                  </div>
                  <div id="progress-control" className={`${styles['progress-control']} ${menushow === false ? styles['scroll'] : ''}`}>
                    <span className={styles['progress-info']}> {lang == 'et' ? (<>Samm </>) :  lang == 'en' ?(<>Step </>) : (<>Шаг </>)}
                     {block.progress} / {progress.length}</span>
                    
                   
                  </div>
                  <div className={styles['progress-indicator']}>
                    <table width={100 * block.progress / maxprogress + '%'} className={styles['progress']}></table>
                  </div>
              </div>
            ) : (
              <div className={`${styles['progress-container']}`}>
                 
                  <div className={styles['progress-indicator']}>
                    <table width={100 * block.progress / maxprogress + '%'} className={styles['progress']}></table>
                  </div>

                  <div id='headerlogo' className={`${styles['logo']} ${menushow === false ? styles['scroll'] : styles['mobileshow']} text-center pt-2`}>
                      <img src="https://app.hugo.legal/assets/hugolegacom/img/media/logo_hugo.png" alt='' rel=""/>
                  </div>
              </div>
            )}
        <div className={`${styles['app-promo']}`}>
                <div className={`${styles['logo']} text-center pt-2`}>
                  <img src="https://app.hugo.legal/assets/hugolegacom/img/media/logo_hugo.png" alt='' rel=""/>
                  </div>
                
      
                {/*  {(!isNaN(parseFloat(block.progress)) && isFinite(block.progress)) ? ( */}


                {progress !== undefined  ? (
                <div className={`${styles['progress-desk-container']}`}>
                    {progress?.map((item, index) => (

                          <div 
                          key={item.id} 
                          className={`${styles['progress-desk-header']} ${block.progress > item.step ? styles['done'] : block.progress === item.step ? styles['active'] : styles['next']}`}>
                              {block.progress > item.step ? (<i className={`fa fa-check`}></i>) : block.progress === item.step ?  (<i className={`fa fa-circle`}></i>) : (<i className={`fa fa-circle-o`}></i>)}
                              <span>{lang == 'et' ? (<>Samm </>):  lang == 'en' ?(<>Step </>) : (<>Шаг </>)} {item.step}<br/>
                              {item.value}</span>
                          </div>                              
                              
                     ))}
                  </div>
                ):(
                  <>
                  <div className={`${styles['watermark']}`}>
                  <img src="https://hugo.legal/wp-content/uploads/2023/01/hugowatermark.png" alt='' rel=""/>
                  </div>
                  </>
                )}

            <Media lang={lang}/>   

            {chatbot != null && (
              <div>                 
                <div className={`${styles['app-promo-text']}`}>{chatbot.chatbot.description}</div>
                <div className={`${styles['app-promo-area']}`} dangerouslySetInnerHTML={{__html: chatbot.chatbot.img}}></div>
              </div>
            )}
        </div>
       
        <div className={`${styles['chat-wrapper']} ${editmode === true ? styles['editmode'] : ''}`}>
         
      
 

          <div  onScroll={handleScroll} id="chat-body" ref={body} className={`${styles['chat-body']} ${menushow === false ? styles['scroll'] : ''}`}>
    
      
               <div ref={contentcontainer} className={styles['app-content']} id="content">


                  <div ref={messagecontainer} id="message-container">

                  {loggedIn ? (
      <button  onClick={handleLogout}>Logout {clientName}</button>
    ) : (
      <></>
    )}
                  
                    {messages?.map((message, index) => {
                    return message.user === 'user' ? 
                      (
                      <div key={index}></div> //SIIN SAADAB KASUTAJA SÕNUMI VÄLJA; SEDA OSA VÕIKS ÜLDSE MITTE OLLA
                      ) : ( message.msg && block.type !== 'condition' && block.type !== 'document' && block.type !== 'email' && block.type !== 'sheet' && block.type !== 'calculation' && block.type !== 'scoro' && !error && !waiting &&(
                          <div key={index}>
                            <div className={styles['message-wrapper']}>
                              <div className={styles['message-wrapper-row']}>
                                <div className={styles['progressheader']}>{block.progressheader}</div>
                                <div id="last-message"
                                  className={`${styles['message-solo']} hugomessage active`}
                                  dangerouslySetInnerHTML={{__html: message.msg}}
                                ></div>
                              
                              
                                <div>
                                  <i  className={`${styles['modallink']}`} onClick={openModal}>{block.modallink}</i>
                                
                                </div>

                              </div>
                            </div>
                          </div>
                        )
                        );
                    })}


                

                  </div>

                  {/* <div ref={replycontainer} className={styles['message-extra']} id="reply-container"> */}

                  {block.type === 'text' && !waiting &&(
                    <>
                    <span  
                        dangerouslySetInnerHTML={{__html: block.notification}} 
                        className={`${styles['widget_notification']} widget_notification`}
                        ></span>
                    <div  className={`${styles['buttons']}`}>
                    {block.button === true && buttonshow &&(
                      <button 
                            dangerouslySetInnerHTML={{__html: block.buttontext}} 
                            onClick={async () => {reply("0");}} //VAJAPARANDADA
                            className={`${styles['chat__next__button']} chat__next__button`}
                            >
                        </button>
                    )}
                    </div>
                    </>
                  )}

                  {block.type === 'richText' && !waiting &&(
                    <div className={styles['chat-footer']}>
                    <button 
                          dangerouslySetInnerHTML={{__html: block.buttontext}} 
                          onClick={async () => {reply("0");}} //VAJAPARANDADA
                          className={`${styles['chat__next__button']} chat__next__button`}
                          >
            
                      </button>
                    </div>
                  )}  

                  {block.type === 'review' && reviews.ready === "ready" && !waiting &&(

                    <>
                          <div className={styles['chat-footer']}>
                      

                                <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                                      {block?.reviews?.map((item, index) => (
                                          <div key={index}>
                                                <div className={`${styles['chat_edit_h']}`} >{reviews.reviewelementsData[index].headtext}</div>
                                                <div 
                                                onClick={() =>  {getBlock(reviews.reviewelementsData[index].id)}}  
                                                className={`${styles['chat__edit__input']} chat__edit__input`}
                                                >{reviews.data[item.element.label]}<i className={`fa fa-pencil`}></i>
                                                </div>
                                          </div>
                                      ))}
                                </div>

                            

                            </div>  
                          
                            <div className={`${styles['buttons']}`}>

                                <button 
                                    dangerouslySetInnerHTML={{__html: block.buttontext}} 
                                    onClick={async () => {reply("0");}} //KONTROLLIDA
                                    className={`${styles['chat__next__button']} chat__next__button`}
                                    >
                                </button>
                            </div>
                          

                          
                            </>
                             
        
                  )}
              
                  {block.type === 'share' && !waiting &&(

                    <>
                      <div className={styles['chat-footer']}>
                          <div className="input-group">
                                    <div className={`${styles.inputname}`}>{block?.emailhint}</div>
                                    <input
                                      as="input"
                                      ref={emailsRef}
                                      type="hidden"
                                      id="reply"
                                      name="reply"
                                      className={`${styles.formInput}`}
                                      placeholder={block?.hint ? block.hint : ''}
                                      required
                                    />

                                    <input  
                                      as="input"
                                      id="inputemail"
                                      name="inputemail"
                                      ref={shareEmail}
                              
                                      className={`${styles['formInput']} ${styles['share-input']}`}
                                      placeholder={block?.emailhint ? block.emailhint : 'Lisa sõber'}
                                      onKeyDown={async (e) => {
                                        if (e.code === 'Enter' && e.key === 'Enter') {
                                          const valid = Joi.string().email({tlds:{allow: false}}).validate(shareEmail.current.value);
                                            
                                          if(valid.error){
                                            console.log("is not" + valid)
                                            setShareValidations( shareEmail.current.value + "is not a valid email aadress!")
                                            shareEmail.current.value = "";
                                          }
                                          else{
                                            setShareValidations("");
                                            setOption(shareEmail.current.value);
                                            shareEmail.current.value = "";
                                            
                                          }
                                        }
                                      }}
                                    />

                                    <button 
                                      className={`${styles['chat__next__button']} ${styles['share-input-btn']} `}
                                      type="button"
                                      
                                      onClick={async () => {
                                        
                                            const valid = Joi.string().email({tlds:{allow: false}}).validate(shareEmail.current.value);
                                            
                                            if(valid.error){
                                              setShareValidations( shareEmail.current.value + "is not a valid email aadress!")
                                              shareEmail.current.value = "";
                                            }
                                            else{
                                              setShareValidations("");
                                              setOption(shareEmail.current.value);
                                              shareEmail.current.value = "";
                                              
                                            }
                      
                                      
                                      }}
                                    ><i className={`fa fa-plus`} aria-hidden="true"></i></button>
                                    
                                    <div className={styles['red']}>{ sharevalidations }</div>

                                    {components.map((item, i) => ( 
                                      <span key={i}  className={styles['share-emaillist']} id={item}
                                        onClick={async () => {
                                          removeComponent({item}.item);
                                        }}>
                                        <i className={`fa fa-close`}></i>
                                        {item}
                                        </span>
                                    ),[])} 

                                    
                                    <div className={styles['red']}>{ sharemessagevalidations }</div>


                                    <textarea
                                      ref={messageRef}
                                      as="textarea"
                                      type='textarea'
                                      id="textarea"
                                      name="rextarea"
                                      className={`${styles['input-textarea']} ${styles['top']}`}
                                      rows={4}                            
                                      value={shareMessage}
                                      onInput={resizeTextarea}
                                      onChange={event => setShareMessage(event.target.value)}
                                      placeholder={block?.hint ? block.hint : 'Sinu sõnum'}
                                      required
                                    />

                                  
                                




                              
                                    <div
                                      className={`${styles['input-textarea']} ${styles['bottom']} ${styles['locked']}`}
                                      dangerouslySetInnerHTML={{__html: block?.lockedmessage}}
                                      >

                                    
                                    </div>

                                </div>
                            </div>

                               
                               
                               
                               
                                <div  className={`${styles['buttons']}`}>

                                 {editmode === false && buttonshow &&(

                                  <>
                                     
                                      <button
                                        dangerouslySetInnerHTML={{__html: block.buttontext}} 
                                        onClick={async () => {
                                          if(components.length < 1){
                                            setShareValidations(block.validationEmail)
                                          }
                                          if(Joi.string().validate(messageRef.current.value).error){
                                            setShareValidationsMessage(block.validationMessage)
                                          }else{setShareValidationsMessage()}
                                          if(components.length > 0 && !Joi.string().validate(messageRef.current.value).error){
                                            const rep = {};
                                            emailsRef.current.value = components;
                                            rep.message = messageRef.current.value;
                                            rep.emails = emailsRef.current.value;
                                            reply(rep)
                                          }
                                        
                                      }}
                                      className={`${styles['chat__next__button']} chat__next__button`}
                                      >
                                      </button>


                                      { block.next_secondary !== undefined && block.next_secondary !== ""  && (

                                        <button   
                                        onClick={async (e) => {
                                            onReply(e, true) 
                                            
                                        }}
                                        type="submit"
                                        className={`${styles['chat__next_secondary__button']}`}
                                        > {block.secondbutton}
                                        </button>

                                        )}
                                  </>

                                  )}  

                                  {editmode && (
                                            <button
                                                type="submit"
                                                onClick={async () => {
                                                    //reply();
                                                    
                                                    console.log(reviewhome)
                                                    getBlock(reviewhome)
                                                }}
                                                className={`${styles['chat__edit__button']} chat__edit__button`}
                                              >{lang === 'en' ? (<>Save changes</>):(<>Salvesta muudatused</>)}</button>    
                                      )}

                                </div>  


                         </>

                         

                  )}

                  {block.type === 'decision' && !waiting &&(
                    
                        <>
                          {/* <div id="multiple-choice"> */}                 
                          
                        
                            {block.decisions.length === 2 ? (
                              <>
                              <div className={styles['chat-footer']}>  
                                    <span  
                                    dangerouslySetInnerHTML={{__html: block.notification}} 
                                    className={`${styles['widget_notification']} widget_notification`}
                                    ></span>
                                </div>

                                
                                  <div  className={`${styles['buttons']}`}>

                                    

                                      <button
                                        dangerouslySetInnerHTML={{__html: Object.values(block.decisions)[0].text}} 
                                        onClick={async () => {
                                          reply( Object.values(block.decisions)[0].value);
                                        }}
                                        className={`${styles['chat__next__button']} chat__next__button`}
                                      >
                                      </button>

                                      <button
                                        dangerouslySetInnerHTML={{__html: Object.values(block.decisions)[1].text}} 
                                        onClick={async () => {
                                        reply(Object.values(block.decisions)[1].value );
                                        }}
                                        className={`${styles['chat__next_secondary__button']}`}
                                      >
                                      </button>


                                        


                                   </div>
                                </>
                              

                            ) : block.decisions.length === 1 ?(
                              <>
                              <div className={styles['chat-footer']}>  
                                  <span  
                                  dangerouslySetInnerHTML={{__html: block.notification}} 
                                  className={`${styles['widget_notification']} widget_notification`}
                                  ></span>
                                  </div>
                              
                                <div  className={`${styles['buttons']}`}>          

                                  <button
                                      dangerouslySetInnerHTML={{__html: block.decisions[0].text}} 
                                      onClick={async () => {
                                        reply(block.decisions[0].value);
                                      }}
                                      className={`${styles['chat__next__button']} chat__next__button`}
                                    >
                                    </button>

                                </div>
                            </> 


                            ):(

                              <> 
                                 <div 
                                     className={`${styles['chat-footer']} ${buttonsticky === true ? styles['sticky'] : ''} `}

                                 >  
                                  <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              
                                    {block?.decisions?.map((item, index) => (
                                      <div key={index}>
                                        
                                      <input
                                        id={item.text}
                                        type="radio"
                                        value={item.value}
                                        name="decision"
                                        onClick={(e) => {
                                          setchatInput(item.value);
                                          setButtonSticky(true);
                                        }}
                                        checked={chatInput === item.value}
                                        className={`${styles['chat__radio__input__button']} chat__radio__input__button`}                   
                                        {...radioChoiceProps}
                                      />
                                        <label  htmlFor={item.text} className={`${styles['chat__radio__button']} chat__radio__button`}> 
                                      
                                        {item.img && typeof item.img === 'string' && item.img.length  > 3 ? (
                                          <div className={styles['chat_radio_img_container']}> 
                                        <img className={styles['chat_radio_img']} src={item.img} alt={item.altText} />
                                        </div>
                                        ) : (
                                          <div className={styles['chat_radio_img_alt']}></div>
                                        )}

                                        <div className={styles['chat_radio_textgroup']}>
                                          {item.text}
                                          {/* <div className={styles['icon']}><i class="fa fa-check"></i></div> */}
                                          <div className={`${styles['chat__radio__check'] }`}><span class="fa fa-check"></span></div>
                                          <br/>
                                        <span dangerouslySetInnerHTML={{__html: item.content}} ></span>
                                        </div>
                                        </label>
                                        
                                      </div>
                                      
                                    ))}
                                      <div className={styles['red']}>{ decisionvalidations }</div>

                                      <span  
                                      dangerouslySetInnerHTML={{__html: block.notification}} 
                                      className={`${styles['widget_notification']} widget_notification`}
                                      ></span>
                                  </div>
                                  </div>




                                  <div  
                                    className={`${styles['buttons']} ${buttonsticky === true ? styles['sticky'] : ''} border-end-0`}

                                  >
                                                                  
                                      <button
                                          dangerouslySetInnerHTML={{__html: block.buttontext}} 
                                          onClick={async () => {
                                            console.log(chatInput)
                                            if (!chatInput){
                                              setDecisionValidation(block?.validationMessage)
                                              _scroll();
                                            } else {
                                              setDecisionValidation('');
                                              reply(chatInput);
                                            }
                                          }}
                                          className={`${styles['chat__next__button']} chat__next__button`}
                                        >
                                      </button>
                                        
                                  </div>



                                    
                              </>
                            
                            )}
                        
                            
                          
                      
                            
                      
                          

                           {/* </div> */}
                   
                      </>                    
                  )}

                  {block.type === 'multipleChoice' && !waiting &&(
                    



                      <div id="multiple-choice">
                      
                        {block.selecttype === "radio" && (    
                                <div>  

                                  <div className={styles['chat-footer']}>

                                    <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                                    {block?.options?.map((item, index) => (
                                        <div key={index}>
                                        <input
                                          id={item.value}
                                          type="radio"
                                          value={item.value}
                                          name="choice"
                                          onClick={(e) => setchatInput(item.value)}
                                          checked={chatInput === item.value}
                                          className={`${styles['chat__radio__input__button']} chat__radio__input__button`}
                                          {...radioChoiceProps}
                                        />
                                        <label  htmlFor={item.value} className={`${styles['chat__radio__button']} chat__radio__button`}> 

                                           <>
                                            <div className={styles['chat_radio_img_alt']}></div>                               
                                              <div className={styles['chat_radio_textgroup']}>
                                               {item.value}<div className={`${styles['chat__radio__check'] }`}><span class="fa fa-check"></span></div>
                                              </div>
                                             </>
                                          </label>
                                        </div>
                                    ))}
                                    </div>
                                    <div className={styles['red']}>{ decisionvalidations }</div>

                                        
                                    <span  
                                      dangerouslySetInnerHTML={{__html: block.notification}} 
                                      className={`${styles['widget_notification']} widget_notification`}
                                    ></span>
                                  </div>


                                <div  className={`${styles['buttons']}`}>
                                  {editmode === false && (
                                    <button
                                    dangerouslySetInnerHTML={{__html: block.buttontext}} 
                                    onClick={async () => {
                                      if (!chatInput){
                                        setDecisionValidation(block?.validationMessage)
                                        _scroll();
                                      } else {
                                        setDecisionValidation('');
                                        reply(chatInput);
                                      }
                                  }}
                                  className={`${styles['chat__next__button']} chat__next__button`}
                                  >
                                  </button>
                                  )}    

                                  {editmode && (
                                          <button
                                              onClick={async () => {
                                                  //reply();
                                                  const selectedOption = radioChoice;
                                                    if (selectedOption) {
                                                      reply(selectedOption, reviewhome, true);
                                                    }
                                                
                                              }}
                                              className={`${styles['chat__edit__button']} chat__edit__button`}
                                            >{lang === 'en' ? (<>Save changes</>):(<>Salvesta muudatused</>)}</button>                    
                                  )}
                                </div>
                                
                                </div>
                          )}



                        {block.selecttype === "select" && (      
                                <div>   
                                  <div className={styles['chat-footer']}>
                                    
                                      <div className={`${styles.inputname}`}>{block?.inputname}</div>

                                      <div className="input-group">
                                        
                                          {chatInput ? (
                                            <input
                                                as="input"
                                                id="reply"
                                                name="reply"
                                                value={chatInput}
                                                onClick={event => setchatInput()}
                                                className={`${styles.formInput}`}
                                                placeholder={block?.hint ? block.hint : ''}  
                                              
                                              />
                                          ) : (
                                          <Select
                        
                                            ref={optionSelectRef}
                                            autoFocus={true}
                                            defaultMenuIsOpen={true}
                                            options={block.options}
                                            id="choice"
                                            name="choice"
                                            className={styles['multiple-choice-selector']}
                                            placeholder={block?.hint ? block.hint : ''}
                                            classNamePrefix="react-select"
                                            menuPlacement="auto"
                                            onKeyDown={async (e) => {
                                              if (e.code === 'Enter' && e.key === 'Enter') {
                                                const selectedOption = optionSelectRef.current.state.value;
                                                if (!selectedOption) {
                                                  setDecisionValidation(block?.validationMessage)
                                                  _scroll();
                                                } else {
                                                  setDecisionValidation('');
                                                  reply(selectedOption.label);
                                                }
                                              }
                                            }}
                                          />
                                          )}
                                          
                                      </div>
                                            
                                      <div className={styles['red']}>{ decisionvalidations }</div>

                                        <span  
                                        dangerouslySetInnerHTML={{__html: block.notification}} 
                                        className={`${styles['widget_notification']} widget_notification`}
                                      ></span>
                                  </div>



                                

                                    <div  className={`${styles['buttons']}`}>

                                      {editmode === false && (
                                            <button
                                            dangerouslySetInnerHTML={{__html: block.buttontext}} 
                                            onClick={async () => {
                                              
                                              if (chatInput){
                                                setDecisionValidation('');
                                                reply(chatInput);
                                              }else{
                                                const selectedOption = optionSelectRef.current.state.value;
                                                if (!selectedOption) {
                                                  setDecisionValidation(block?.validationMessage)
                                                  _scroll();
                                                } else {
                                                  setDecisionValidation('');
                                                  reply(selectedOption.label);
                                              }}
                                            }}
                                            className={`${styles['chat__next__button']} chat__next__button`}
                                          ></button>
                                      )}    

                                      {editmode && (
                                            <button
                                              onClick={async () => {
                                                const selectedOption = optionSelectRef.current.state.value;
                                                if (selectedOption) {
                                                  reply(selectedOption.label, reviewhome, true);
                                                }
                                              }}
                                              className={`${styles['chat__edit__button']} chat__edit__button`}
                                            >{lang === 'en' ? (<>Save changes</>):(<>Salvesta muudatused</>)}</button>              
                                      )}
                                    </div>

                                </div>
                        )}



                          
                      


                      </div>
                   
                  )}


                  {block.type === 'match' && !waiting && (


                   <>
                   <div className={`${styles['chat-footer']} ${buttonsticky === true ? styles['sticky'] : ''} `}>
                     
                    <div className={styles['match-container']}>

                      {matchedLawyers.map((lawyer, index) => (
                       
                       <div
                          key={index}
                          className={`${styles['lawyer-card']} ${selectedLawyer?.id === lawyer.id ? styles['selected'] : ''}`}
                          onClick={() => handleLawyerSelect(lawyer)}
                        >
                           <div className={styles['icon']}><i class="fa fa-check"></i></div>
                           
                          <div className={styles['lawyer-info']}>
                            <img src={lawyer.picture} alt={lawyer.picture} className={styles['lawyer-image']} />
                            <div className={styles['lawyer-details']}>
                              <h3>{lawyer.name}</h3>

                              {block?.selectedservice !== 'web' && (
                              <p>{getTranslation('firstAvailableTime', block?.lang)}<br/> {lawyer?.firstAvailableTimeslot}</p>
                              )}

      
                              {block?.selectedservice === 'kiir' ? (
                                <>
                                  <span className={styles['lawyer-price']}>{lawyer.quick_price} </span>
                                  <span className={styles['blue']}>{getTranslation('perMinute', block?.lang)}</span>
                                </>
                              ) : block.selectedservice === 'video' || block.selectedservice === 'web' ? (
                                <>
                                  <span className={styles['lawyer-price']}>{lawyer.hourly_price / 2} </span>
                                  <span className={styles['blue']}>{getTranslation('perHalfHour', block?.lang)}</span>
                                </>
                              ) : (
                                <>
                                  <span className={styles['lawyer-price']}>{lawyer.hourly_price} </span>
                                  <span className={styles['blue']}>{getTranslation('perHour', block?.lang)}</span>
                                </>
                              )}


                            </div>
                          </div>
                          <div className={styles['lawyer-description']}>
                            <p>{lawyer.description}</p>
                               {block?.lang === 'en' ? (
                                <>
                                  <p><b>Lawyer fee: {lawyer.hourly_price}€/hour </b></p>
                                  <p><b>Location: {lawyer.city}</b></p>
                                  <a href="#" onClick={() => handleMoreInfoClick(lawyer)} className={styles['more-info']}>Read more</a>
                                  </>
                               ) : block?.lang === 'ru' ? (
                                <>
                                  <p><b>Гонорар юриста: {lawyer.hourly_price}€/час </b></p>
                                  <p><b>Местоположение: {lawyer.city}</b></p>
                                  <a href="#" onClick={() => handleMoreInfoClick(lawyer)} className={styles['more-info']}>Подробнее о юристе</a>
                                  </>
                               ):
                               (
                                <>
                                  <p><b>Juristi tasu: {lawyer.hourly_price}€/tund </b></p>
                                  <p><b>Asukoht: {lawyer.city}</b></p>
                                  <a href="#" onClick={() => handleMoreInfoClick(lawyer)} className={styles['more-info']}>Loe juristist lähemalt</a>
                                  </>
                               )}
                              
                          </div>
                        </div>
                      ))}
                    </div>

                    
                    

          
                    <span
                      dangerouslySetInnerHTML={{ __html: block.notification }}
                      className={`${styles['widget_notification']} widget_notification`}
                    ></span>
                    </div>
          
                    <div 
                    className={`${styles['buttons']} ${buttonsticky === true ? styles['sticky'] : ''} border-end-0`}

                    >
                      <button
                        dangerouslySetInnerHTML={{ __html: block.buttontext }}
                        onClick={async () => {
                          if (selectedLawyer) {
                            let userReply = [];
                            userReply.push(selectedLawyer.crm_id)
                            setWaitmessage()
                            await callApi(block.id, userReply, false);
                          
                          }
                        }}
                        className={`${styles['chat__next__button']} chat__next__button`}
                      >
                      </button>
                      {block.next_secondary !== undefined && block.next_secondary !== ""  && (

                          <button   
                          onClick={async (e) => {
                              onReply(e, true)  

                              /* reply(false) */
                              /* reply("skipped", undefined, true) */
                          }}

                          type="submit"
                          className={`${styles['chat__next_secondary__button']}`}
                          > {block.secondbutton}
                          </button>

                          )}
                    </div>
                    </>
                  )}
 
                  {block.type === 'calendar' &&  !waiting && block.lawyerdata && (
                    <>
                        
                        <div className={`${styles['chat-footer']} ${buttonsticky === true ? styles['sticky'] : ''} `}> 

                           <>
                           <div className={styles['lawyer-card-calendar']}>

                          <div className={styles['lawyer-info']}>
                            <img src={block?.lawyerdata?.picture} alt={block?.lawyerdata?.name} className={styles['lawyer-image']} />
                            <div className={styles['lawyer-details']}>
                              <h3>{block?.lawyerdata?.name}</h3>
                              {block?.lang === 'en' ? (
                                <>
                                     <p><b>Lawyer</b><br/>
                                      Lawyer fee: {block?.lawyerdata?.hourly_price} €/hour <br/>
                                      Location: {block?.lawyerdata?.city}</p>
                                </>
                               ) : block?.lang === 'ru' ? (
                                <>
                                <p><b>Юрист</b><br/>
                                Гонорар юриста: {block?.lawyerdata?.hourly_price} €/час <br/>
                                Местоположение: {block?.lawyerdata?.city}</p>
                                </>
                               ):
                               (
                                <>
                                     <p><b>Jurist</b><br/>
                                     Juristi tasu: {block?.lawyerdata?.hourly_price} €/tund <br/>
                                     Asukoht: {block?.lawyerdata?.city}</p>
                                </>
                               )}
                           
                            </div>
                          </div>
                          </div>
                          </>
                          
                        

                          <div className={styles['calendar']}>
                                 {Object.keys(timeslots).map((dateKey) => (
                                  <>
                                    <div className={styles['calendar-date']}>{dateKey}</div>
                                    {timeslots[dateKey].map((slot) => (
                                      <div
                                        key={slot.id}
                                        onClick={() => handleSlotSelect(slot)}
                                        className={`${styles['lawyer-card']} ${styles['calendar-slot']} ${selectedSlot?.id === slot.id ? styles['selected'] : ''}`}
                                      >
                                        <div className={styles['icon']}><i className="fa fa-check"></i></div>
                                        <div className={styles['calendar-time']}>{slot.start_time}</div>

                                        {block?.selectedservice === 'kiir' ? (                    
                                          <div className={styles['calendar-service']}>{block?.lawyerdata?.quick_price}€ / 25min</div>

                                        ): block.selectedservice === 'video' || block.selectedservice === 'web' ? (                                   
                                          <div className={styles['calendar-service']}>{block?.lawyerdata?.hourly_price / 2}€ / 30min</div>
                                        ):(
                                          
                                          <div className={styles['calendar-service']}>{block?.lawyerdata?.hourly_price}€ / 60min</div>

                                        )} 

                                        
                                      </div>
                                    ))}
                                  </>
                                ))}
                                </div>

                         </div>

                      <div 
                      className={`${styles['buttons']} ${buttonsticky === true ? styles['sticky'] : ''} border-end-0`}
                      >
                      <button
                        dangerouslySetInnerHTML={{ __html: block.buttontext }}
                        onClick={async () => {
                          if (selectedSlot) {
                            let userReply = [];
                            userReply.push(selectedSlot);
                            setWaitmessage()
                            await callApi(block.id, userReply, false);
                          }
                        }}
                        className={`${styles['chat__next__button']} chat__next__button`}
                      >
                      </button>
                      
                      {block.next_secondary !== undefined && block.next_secondary !== ""  && (

                      <button   
                      onClick={async (e) => {
                          onReply(e, true)  
                          /* reply(false) */
                          /* reply("skipped", undefined, true) */
                      }}

                      type="submit"
                      className={`${styles['chat__next_secondary__button']}`}
                      > {block.secondbutton}
                      </button>

                      )}
                    </div>
                      
                    </>
                  )}

                  {block.type === 'booking' && !waiting &&(
                    <div id="message-wrapper-decisions">
                      {block?.types?.map((item, i) => (
                        <span
                          key={i}
                          className="btn btn-outline-primary btn-sm"
                          onClick={(ev) => {
                            reply(item);
                          }}
                        >
                          {item}
                        </span>
                      ))}

                      {block?.timeSlots?.map((slot) => (
                        <span
                          key={slot.id}
                          className="btn btn-outline-primary mx-2 btn-sm"
                          onClick={(ev) => {
                            reply(slot.id, ev.target.innerText);
                          }}
                        >
                          {slot.date} - {slot.start_time}-{slot.end_time}
                        </span>
                      ))}
                    </div>
                  )}

                  {block.type === 'payment' && !waiting &&(
                        <>                        
                        <div className={styles['chat-footer']}>  

                              {block?.link &&(
                                    <div>
                                      
                                    </div>
                              )} 

                              <span  
                              dangerouslySetInnerHTML={{__html: block.notification}} 
                              className={`${styles['widget_notification']} widget_notification`}
                              ></span>
                                
                              </div>
                              
                              <div  className={`${styles['buttons']}`}>

                        
                              
                                     {block?.success ? (

                                          <button
                                          dangerouslySetInnerHTML={{__html: block?.buttontext}} 
                                          onClick={async () => {       
                                            reply('next')
                                          }}
                                          className={`${styles['chat__next__button']} chat__next__button`}
                                          ></button>
                                          ):(
                                            <button
                                            dangerouslySetInnerHTML={{__html: block?.buttontext}} 
                                            onClick={async () => {
                                                  var action = 'payment'
                                                  let datas = {action, botId}
                                                  reply(datas)
                                            }}
                                            className={`${styles['chat__next__button']} chat__next__button`}
                                          >
                                          
                                          </button>

                                          )}

                                  

                            </div>
                            
                            </>

                  )}

                  {block.type === 'upload' && !waiting && (
                    <>
                      <span  
                          dangerouslySetInnerHTML={{__html: block.notification}} 
                          className={`${styles['widget_notification']} widget_notification`}
                       ></span>


                     {lang === 'et' ? (
                      <div className={`${styles['message-wrapper-row']}`}  id="upload-container">
                         <span className={`${styles.red}`}>{validationMessage}</span>

                          <div className={`${styles['file-drop-zone']}`} {...getRootProps()}>
                            <div className={`text-center`}><img className={`${styles['drop-icon']}`} src="/media/upload.png" alt=""></img></div>
                            
                           {/*  <p>{`Click to select files (${block?.acceptedTypes?.toString()}) or drag and drop in desktop `}</p> */}
                            <p>{`Vali failid või lohista desktopilt `}</p>
                            <label className={`${styles['uploadselect']}`}>
                              
                               {/*  Select files */}
                                Vali failid
                            </label>

                            <input  {...getInputProps({multiple: true})} />
                      
                           

                          </div>

         


                         {/*  <button type="button" onClick={handleCaptureClick}>
                            Take Photo
                            </button>


                            <button type="button" onClick={handleSelectClick}>
                              Choose from Library
                            </button> */}
                          

                            {/* <p>
                                <label for="cameraFile">Take a picture:</label>
                                <input name="cameraFile" type="file" capture="environment" accept="image/*"/>
                            </p> */}
                          <div>
                            <p className={`${styles['uploadinfo']}`}>

                            {/* File formats: */}
                            Sobivad formaadid: 
                            <br/>
                            {/* {`(${block?.acceptedTypes?.toString()}) `}, with the maximum <strong>size up to {block?.sizeLimit} MB</strong> */}
                            {`(${block?.acceptedTypes?.toString()}) `}, maksimaalse <strong> suurusega {block?.sizeLimit} MB</strong>
                            </p>
                          </div>


                         {/* Dont display thumbs atm */}
                         {thumbs}

                       </div>
                       ):(
                        <div className={`${styles['message-wrapper-row']}`}  id="upload-container">
                        <span className={`${styles.red}`}>{validationMessage}</span>

                         <div className={`${styles['file-drop-zone']}`} {...getRootProps()}>
                           <div className={`text-center`}><img className={`${styles['drop-icon']}`} src="/media/upload.png" alt=""></img></div>
                           
                          {/*  <p>{`Click to select files (${block?.acceptedTypes?.toString()}) or drag and drop in desktop `}</p> */}
                           <p>{`Choose files or drag from computer `}</p>
                           <label className={`${styles['uploadselect']}`}>
                             
                              {/*  Select files */}
                               Choose files
                           </label>
                           <input {...getInputProps({multiple: true})} />
                         </div>
                         <div>
                           <p className={`${styles['uploadinfo']}`}>

                           {/* File formats: */}
                            Accepted file types: 
                           <br/>
                           {/* {`(${block?.acceptedTypes?.toString()}) `}, with the maximum <strong>size up to {block?.sizeLimit} MB</strong> */}
                           {`(${block?.acceptedTypes?.toString()}) `} with maximum <strong> size {block?.sizeLimit} MB</strong>
                           </p>
                         </div>
                     
                        {thumbs}

                      </div>

                       )}
                     
                       <div className={`${styles['buttons']}`}>

                          { buttonshow &&   
                          <>

                                {files.length > 0 && (
                                  <button
                                    
                                    id="upload-submit-button"
                                    onClick={async () => {


                                      const formData = new FormData();
                                      formData.append('id', block.id);
                                      formData.append('fileName', block.variable)

                                      files.forEach((file) => {
                                        console.log(block.variable)
                                        formData.append('name', file.name)
                                        formData.append('files', file);
                                      });

                               

                                      

                                      
                                       
                                      /* files.forEach((file) => {
                                       // getBlobFromPreview(file.preview, blob => {
                                     
                                         const formData = new FormData();
                                         formData.append('id', block.id);
                                         formData.append('fileName', block.variable)
                                         
                                         console.log(file)
                                        
                                         fileToBlob(file, (blob) => {

                                          console.log(blob)
                                         // const file2 = new File([blob], "filename.jpg", {type: blob.type, lastModified: Date.now()});
                                         // console.log(file2)

                                          formData.append('files', blob, file.name);
                                          uploadFile(block.id, formData);
                                          // Now send this formData to your backend
                                         });

                                          //const file = new File([blob], file.name, {type: blob.type, lastModified: Date.now()});
                                         // formData.append('files', file);
                                        //  formData.append('files', blob,  file.name);                                      
                                        //});
                                      }); */

                                      await uploadFile(block.id, formData);

                                  
                                      setFiles([]);
                                      


                                      /* console.log(dataurl)
                                      alert(dataurl)
                                      reply(dataurl) */

                                    }}
                                    className={`${styles['chat__next__button']} chat__next__button`}
                                    dangerouslySetInnerHTML={{__html: block.buttontext}} 
                                  >
                                  </button>
                                  
                                )}
                                {/*   <button
                                      onClick={async () => {
                                          reply(false);
                                      }}
                                      className={`${styles['chat__third__button']}`}
                                    >Skip this for now</button>   */}

                                  {block.next_secondary !== undefined && block.next_secondary !== ""  && (

                                            <button   
                                            onClick={async (e) => {
                                                onReply(e, true)  
                                                /* reply(false) */
                                                /* reply("skipped", undefined, true) */
                                            }}
                                        
                                            type="submit"
                                            className={`${styles['chat__next_secondary__button']}`}
                                            > {block.secondbutton}
                                            </button>

                                    )}
                                </>

                            }

                          
                      </div>

                      </>
                    
                  )}

                  {block.type === 'login' && auth && !waiting && (

                    <>

                    <div className={styles['chat-footer']}>


                      <div className={`${styles.inputgroup}`}>

                   
                          {block.verify ? (
                            <>

                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              {block?.verifytype === 'email' ?(
                              <>
                              <div className={`${styles.inputname}`}>{block?.email_name}</div>
                              <input
                                ref={loginEmailRef}
                                id="email"
                                name="email"
                                value={loginEmail}
                                
                                className={`${styles['formInput']}`}

                                onChange={event => setloginemail(event.target.value)}
                                
                                type={`${block.code_validation ? '' : ''}`} 

                                placeholder={block?.usermessage ? block.usermessage : 'Email '}
                                
                              />
                              </>
                              ):(
                              <>
                              <div className={`${styles.inputname}`}>{block?.phone_name}</div>
                              <input
                                ref={loginPhoneRef}
                                id="phone"
                                name="phone"
                                value={loginPhone}
                                
                                className={`${styles['formInput']}`}

                                onChange={event => setloginphone(event.target.value)}
                                
                                type={`${block.code_validation ? '' : ''}`} 

                                placeholder={block?.usermessage ? block.usermessage : 'Phonenumber'}
                              />
                              </>
                              )}
                            </div>

                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              <div className={`${styles.inputname}`}>{block?.code_name}</div>
                              <input
                                ref={loginPassword}
                                id="password"
                                name="password"
                                className={`${styles['formInput']} ${block.code_validation ? styles.formInput_error : ''} border-end-0`}
                                placeholder={block?.usermessage ? block.usermessage : block?.code_hint}
                              />
                            </div>
                            <span className={`${styles.red}`}>{block.code_validation}</span>

                            </>
                             
                          ) : block.register ? (
                            
                            
                            <>
                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              <div className={`${styles.inputname}`}>{block?.firstname_name}</div>
                              <input
                                ref={loginFirstNameRef}
                                id="firstname"
                                name="firstname"
                                value={loginFirstName}
                                onChange={event => setloginfirstname(event.target.value)}
                                className={`${styles['formInput']} ${block.firstname_validation ? styles.formInput_error : ''} border-end-0`}
                                placeholder={block?.usermessage ? block.usermessage : block?.firstname_hint}
                              />
                            </div>
                            <span className={`${styles.red}`}>{block.firstname_validation}</span>
                          
                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              <div className={`${styles.inputname}`}>{block?.lastname_name}</div>
                              <input
                                ref={loginLastNameRef}
                                id="lastname"
                                name="lastname"
                                value={loginLastName}
                                onChange={event => setloginlastname(event.target.value)}
                                className={`${styles['formInput']} ${block.lastname_validation ? styles.formInput_error : ''} border-end-0`}
                                placeholder={block?.usermessage ? block.usermessage : block?.lastname_hint}
                              />
                            </div>
                            <span className={`${styles.red}`}>{block.lastname_validation}</span>
                          
                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              <div className={`${styles.inputname}`}>{block?.phone_name}</div>
                              <input
                                ref={loginPhoneRef}
                                id="phone"
                                name="phone"
                                value={loginPhone}
                                onChange={event => setloginphone(event.target.value)}
                                className={`${styles['formInput']} ${block.phone_validation ? styles.formInput_error : ''} border-end-0`}
                                placeholder={block?.usermessage ? block.usermessage : block?.phone_hint}
                              />
                            </div>
                            <span className={`${styles.red}`}>{block.phone_validation}</span>
                          
                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              <div className={`${styles.inputname}`}>{block?.pidname}</div>
                              <input
                                ref={loginPidRef}
                                id="pid"
                                name="pid"
                                value={loginPid}
                                onChange={event => setloginpid(event.target.value)}
                                className={`${styles['formInput']} ${block.pid_validation ? styles.formInput_error : ''} border-end-0`}
                                placeholder={block?.usermessage ? block.usermessage : block?.pidhint}
                              />
                            </div>
                            <span className={`${styles.red}`}>{block.pid_validation}</span>
                          
                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                              <div className={`${styles.inputname}`}>{block?.email_name}</div>
                              <input
                                ref={loginEmailRef}
                                id="email"
                                name="email"
                                value={loginEmail}
                                onChange={event => setloginemail(event.target.value)}
                                className={`${styles['formInput']} ${block.email_validation ? styles.formInput_error : ''} border-end-0`}
                                placeholder={block?.usermessage ? block.usermessage : block?.email_hint}
                              />
                            </div>
                            <span className={`${styles.red}`}>{block.email_validation}</span>
                          </>
                          
                            ) : (
                            <>
                              <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                                <div className={`${styles.inputname}`}>{block?.inputname}</div>
                                <input
                                  ref={loginEmailRef}
                                  id="email"
                                  name="email"
                                  value={loginEmail}
                                  className={`${styles['formInput']} ${block.email_validation ? styles.formInput_error : ''} border-end-0`}
                                  onChange={event => setloginemail(event.target.value)}
                                  placeholder={block?.usermessage ? block.usermessage : block?.hint}
                                />
                              </div>
                              <span className={`${styles.red}`}>{block.email_validation}</span>

                            </>
                                
                            )}





                              <span className={`${styles.red}`}>{block.validationmessage}</span>


                              <span  
                              dangerouslySetInnerHTML={{__html: block.notification}} 
                              className={`${styles['widget_notification']} widget_notification`}
                              ></span>
                      
                      </div>
                      </div>
                      
                      <div className={`${styles['buttons']}`}>
                                 

                              


                             <button   
                              onClick={async (e) => {
                                let userReply = [];
                                if(block.register){
                                  userReply.push(loginFirstNameRef.current.value);
                                  userReply.push(loginLastNameRef.current.value);
                                  userReply.push(loginPhoneRef.current.value);
                                  userReply.push(loginPidRef.current.value);
                                  userReply.push(loginEmailRef.current.value);
                                }else if(block.verify){
                                  if(block.verifytype === 'email'){
                                    userReply.push(loginEmailRef.current.value);
                                  }else{
                                    userReply.push(loginPhoneRef.current.value);
                                  }
                                   userReply.push(loginPassword.current.value);
                                }else{
                                  userReply.push(loginEmailRef.current.value);
                                }
                                await callApi(block.id, userReply, false);
                               }}
                          
                              type="submit"
                              className={`${styles['chat__next__button']} chat__next__button`}
                              > {block?.button} 
                              </button>

                              {block.verify ? (
                                <button   
                                onClick={async (e) => {
                                  let userReply = [];
                                  if(block.verifytype === 'email'){
                                    userReply.push(loginEmailRef.current.value);
                                  }else{
                                    userReply.push(loginPhoneRef.current.value);
                                  }      
                                  await callApi(block.id, userReply, false);
                                }}
                            
                                type="submit"
                                className={`${styles['chat__next_secondary__button']}`}
                                > {block?.button_sendagain} 
                                </button>
                              ):(
                                <></>
                              )}

                       </div>
                       </>

                  )
                  }

                  {block.type === 'input' && !waiting && (
                    <div className={styles['chat-footer']}>

                        {/* Input method : TEXT ? SIGNATURE */}

                    
                        {block?.inputtype === 'signature' ? (
                          <>
                          
                          
                            <div className="input-group">
                              <div className={`${styles.inputname}`}>{block?.inputname}</div>
                              <div className="input-group">

                                    <div>
                                      <SignatureCanvas 
                                        penColor="black"
                                        canvasProps={{className: styles.signature}}
                                        ref={sigRef}
                                        onEnd={handleSignatureEnd}
                                      />
                                      <button onClick={clearSignature}>Clear</button>
                                    </div>
                          
                     

                              </div>

                              {signatureValidation && (
                              
                              <span className={`${styles.red}`}>{block.validationmessage_sign}</span>
                              
                              )}


                              <span  
                              dangerouslySetInnerHTML={{__html: block.notification}} 
                              className={`${styles['widget_notification']} widget_notification`}
                              ></span>

                            </div>
                          
                          
                          </>



                        ) : (  
                        
                        <>

                        {block.validation === 'money' && block.currency ? (
                          <div className="input-group">
                            <div className={`${styles.inputname}`}>{block?.inputname}</div>
                            <div className="input-group">
                            <span className={`${styles['input-currency']} input-group-text`}>
                              {moneyCurrency.find((i) => i.value === block.currency).sign}
                            </span>
                            <input
                              ref={inputRef}
                              type="text"
                              className={`${styles['formInput']} ${validationstate === true ? styles.formInput_error : ''} border-end-0`}
                              aria-label="Amount (to the nearest dollar)"
                              placeholder={block?.hint ? block.hint : '00.00'}
                              value={chatInput}
                              onChange={event => setchatInput(event.target.value)}
                              onKeyDown={async (e) => {
                                if (e.code === 'Enter' && e.key === 'Enter') {
                                  onReply(e) 
                                  
                                }
                              }}
                            />
                            </div>
                            <span className={`${styles.red}`}>{block.validationmessage}</span>
                            <span  
                            dangerouslySetInnerHTML={{__html: block.notification}} 
                            className={`${styles['widget_notification']} widget_notification`}
                            ></span>

                          </div>
                        ) : block.validation === 'time' ? (
                          <div className="input-group">
                            <div className={`${styles.inputname}`}>{block?.inputname}</div>
                            <DatePicker
                              selected={chatInput ? selectedtime : ''}
                              value={chatInput}
                              ref={inputRef}
                              onChange={(time) => {
                                setSelectedTime(time);
                                setchatInput(time);
                              }}
                      
                              timeFormat="HH:mm"
                              dateFormat="HH:mm"
                              id="time"
                              name="time"
                              placeholderText={block?.hint ? block.hint : 'HH:MM'}
                              className={`${styles['formInput']} ${validationstate === true ? styles.formInput_error : ''} border-end-0`}
                              isClearable={true}
                            
                              showTimeSelect
                              showTimeSelectOnly

                              onKeyDown={async (e) => {
                                if (e.code === 'Enter' && e.key === 'Enter') {
                                    onReply(e);
                                }
                              }}
                            />
                          <span className={`${styles.red}`}>{block.validationmessage}</span>
                            <span  
                            dangerouslySetInnerHTML={{__html: block.notification}} 
                            className={`${styles['widget_notification']} widget_notification`}
                            ></span>


                          </div>
                        ) : block.validation === 'date' || block.validation === 'birthday' ? (
                          <div className={`input-group`}>
                            <div className={`${styles.inputname}`}>{block?.inputname}</div>
                            <MultiDatePicker
                              customInput={<MaskedInput mask={[/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/]} />}
                              format="DD.MM.YYYY"   
                              value={chatInput} // eelnev ja uus vastus
                              onChange={async (e) => {
                                const format = moment(new Date(e)).format('DD.MM.YYYY');
                                setchatInput(format);
                              }}

                              containerStyle={{
                                width: "100%"
                              }}
                              //containerClassName={`${styles['date-container']}`}
                              
                            // className="rmdb-mobile"
                              inputClass={`${styles['formInput']} ${validationstate === true ? styles.formInput_error : ''} border-end-0`}
                              id="date"
                              name="date"
                            
                              placeholder={block?.hint ? block.hint : 'DD.MM.YYYY'}
                              calendarPosition="bottom-left"
                              inputMode="none"
                              isClearable={true}
                              onKeyDown={async (e) => {
                                if (e.code === 'Enter' && e.key === 'Enter') {
                                    
                                        onReply(e);
                                    
                                }
                              }}
                            />
                            <span className={`${styles.red}`}>{block.validationmessage}</span>
                            <span  
                            dangerouslySetInnerHTML={{__html: block.notification}} 
                            className={`${styles['widget_notification']} widget_notification`}
                            ></span>


                          </div>
                        ) : block.validation === 'address' ? (
                          <div className="input-group">
                            <div className={`${styles.inputname}`}>{block?.inputname}</div>
                            {chatInput ? (
                              <input
                                  as="input"
                                  id="reply"
                                  name="reply"
                                  value={chatInput}
                                  onClick={event => setchatInput()}
                                  className={`${styles.formInput}`}
                                  placeholder={block?.hint ? block.hint : ''}  
                                  onKeyDown={async (e) => {
                                    if (e.code === 'Enter' && e.key === 'Enter') {
                                      onReply(e) 
                                      
                                    }
                                  }}
                                />
                            ) : (
                              
                            <GooglePlacesAutocomplete
                              apiKey={process.env.REACT_APP_GOOGLE_AUTO_COMPLETE}
                            
                              selectProps={{
                                ref: {inputRef},
                                onChange: setAddress,
                                value: address,          
                                placeholder: block?.hint ? block.hint : '',
                                className: styles['google-autocomplete-input' ],
                                name: 'address',
                                id: 'address',
                                classNamePrefix: 'address-select',
                                menuPlacement: 'bottom', 
                                autoFocus: true,    
                              }}
                              apiOptions={{ language: 'et', region: 'et' }}
                              autocompletionRequest={{
                                componentRestrictions: {
                                country: ['est'],
                                }
                              }}
                            />
                            
                            )}

                            <span className={`${styles.red}`}>{block.validationmessage}</span>
                            <span  
                            dangerouslySetInnerHTML={{__html: block.notification}} 
                            className={`${styles['widget_notification']} widget_notification`}
                            ></span>


                          </div>
                        ) : (
                          <div className={`${styles.inputgroup}`}>

                            <div className={`${styles['chat__radio__group']} chat__radio__group`}>
                                <div className={`${styles.inputname}`}>{block?.inputname}</div>
                                {validationstate === false && block.inputtype === 'input' ? (
                                  
                                <input
                                  ref={inputRef}
                                  as={block.inputtype}
                                  id="reply"
                                  name="reply"
                                  value={chatInput}
                                  onChange={handleInputChange(block?.characterlimit)}
                                  className={`${styles.formInput}`}
                                  placeholder={block?.hint ? block.hint : ''}  
                                  onKeyDown={async (e) => {
                                    if (e.code === 'Enter' && e.key === 'Enter') {
                                      onReply(e) 
                                    }
                                  }}
                                
                                />

                                ) : block.inputtype === 'textarea' ?(
                                  <textarea
                                  ref={inputRef}
                                  rows = '6'
                                  as={block.inputtype}
                                  id="reply"
                                  name="reply"
                                  value={chatInput}
                                  onChange={handleInputChange(block?.characterlimit)}
                                  className={`${styles.formTextarea}`}
                                  placeholder={block?.hint ? block.hint : ''}  
                                  /* onKeyDown={async (e) => {
                                    if (e.code === 'Enter' && e.key === 'Enter') {
                                      onReply(e) 
                                      
                                    }
                                  }} */
                                
                                />
                                  
                                ) : (
                                  <input
                                    ref={inputRef}
                                    as="input"
                                    id="reply"
                                    name="reply"
                                    className={`${styles.formInput_error}`}
                                    placeholder={block?.usermessage ? block.usermessage : ''}
                                    onKeyDown={async (e) => {
                                      if (e.code === 'Enter' && e.key === 'Enter') {
                                        onReply(e) 
                                        
                                      }
                                    }}
                                  />
                                  )}
                      
                            </div>

                              {block?.characterlimit !== undefined && block?.characterlimit !== null && (
                                  <span className={charactercount<block?.characterlimit ? `${styles.gray}` : `${styles.red}`}>{charactercount}/{block?.characterlimit} tähemärki</span>
                              )}

                            <span className={`${styles.red}`}>{block.validationmessage}</span>
                            <span  
                            dangerouslySetInnerHTML={{__html: block.notification}} 
                            className={`${styles['widget_notification']} widget_notification`}
                            ></span>




                          



                          </div>
                        )}
                        
                        </>
                        )}

                      
                    </div>
                  )}

                  {block.type === 'input' && !waiting && (

                       /*  <div className={styles['chat-footer']}> */
                          <div className={`${styles['buttons']}`}>
                            
                            
                          
                                  {editmode ? (
                                    
                                        <button
                                        onClick={async (e) => {       
                                            console.log(reviewhome)                                   
                                            onReply(e)
                                        }}
                                        className={`${styles['chat__edit__button']} chat__edit__button`}
                                      >{lang === 'en' ? (<>Save changes</>):(<>Salvesta muudatused</>)}</button>    
                                    
                                  )  : buttonshow && underlimit && (
                                    <button 
                                                
                                    onClick={async (e) => { 
                                      if(block?.inputtype === 'signature'){
                                        if (signatureValid){onReply(e)}
                                        else{
                                          setSignatureValidation(true)
                                          return}
                                      }else{
                                      onReply(e)            
                                      }                           
                                    }}
                                  
                                    type="submit"
                                    dangerouslySetInnerHTML={{__html: block.buttontext}} 
                                    className={`${styles['chat__next__button']} chat__next__button`}
                                    >
                      
                              </button>
                                  
                                                  
                            
                            )}

                            { buttonshow && underlimit && !editmode && block.next_secondary !== undefined && block.next_secondary !== ""  && (

                              <button   
                              onClick={async (e) => {
                                  onReply(e, true) 
                              }}
                          
                              type="submit"
                              className={`${styles['chat__next_secondary__button']}`}
                              > {block.secondbutton}
                              </button>

                              )}

                          
                          </div>
                        /* </div> */
                  )}


                  {/* </div> */}


                  {waiting && (
                    <>
                    <div key="indicator" className={styles['message-wrapper']}>
                      {/* <div className={styles['message-wrapper-row']}>
                          <div className={`${styles['waiting']}`} style={{display: 'block'}}>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                      </div> */}
                      <div className={styles['center']}>
                         <Loadinganimation />
                         <br/>
                         <br/>
                         <i>{waitmessage}</i>
                      </div>
                    </div>
                    <div></div>
                    </>
                  )}

                  {error && (
                    <>
                     <div key="indicator" className={styles['message-wrapper']}>
                        <div className={`${styles['message-solo']} hugomessage ${styles['center']}`}>
                            <br/>
                            <p>
                            {lang === "et" ? (errorm):lang === "ru"?(errorm_ru):(errorm_en)}
                            <span id="startagainbtn" onClick={startAgain} className={`${styles['link']}`}>
                                
                                {lang === "et" ? (<>Taaskäivita</>):lang === "ru"?(<>Перезапустить</>):(<>Restart</>)}
                              </span>
                              </p>
                          </div>
                      </div>
                      <div></div>
                    </>
                  )}  

             </div>

           
            

          
          </div>
        </div>
        </div>
      )}
    </>
  );
}

export default memo(Chat);
